/** @auther : IBM **/ /** @date : **/
<template>
	<!-- ========================================== -->
	<!-- 修正日時: 2026-01-22 -->
	<!-- 修正内容: 応対不可ステータスの除外機能追加 -->
	<!--           - .envの設定で応対不可をテーブル表示から除外可能に -->
	<!--           - filteredPresenceTableData computedプロパティでフィルタリング -->
	<!-- ========================================== -->
	<!-- ========================================== -->
	<!-- 修正日時: 2026-01-26 -->
	<!-- 修正内容: TelDetailTableとのマージ - ダイアログ追加 -->
	<!--           - テキストモニタリングダイアログ -->
	<!--           - ボイスモニタリング開始確認ダイアログ -->
	<!--           - 既存モニタリング停止&新規開始確認ダイアログ -->
	<!-- ========================================== -->
	<div>
	<!-- テキストモニタリングDrawer -->
	<!-- ========================================== -->
	<!-- Modified: 2026-04-30 -->
	<!-- Change: Replace el-dialog with el-drawer for text monitoring -->
	<!--         - Use drawer instead of modal dialog -->
	<!--         - Allow background interaction with :modal="false" -->
	<!--         - Similar to Phone component drawer pattern -->
	<!-- ========================================== -->
	<el-drawer
		:visible.sync="dialogVisible"
		:modal="false"
		:with-header="false"
		:show-close="false"
		direction="rtl"
		:size="350"
		:custom-class="textDrawerClass"
		:style="{ 
			right: textDrawerOffset + 'px',
			zIndex: textDrawerZIndex 
		}"
		:before-close="handleClose"
		append-to-body>
		<div class="drawer-header">
			<div class="drawer-header-content">
				<div class="drawer-title">
					<!-- <span v-if="$root.telRealTimeTableData[index] && $root.telRealTimeTableData[index].time">
						{{$root.htmlConst.cons_331_text_monitor}}内線番号 {{ $root.telRealTimeTableData[index].queueNum ==='8899' ?$root.telRealTimeTableData[index].customizedQueueNum:$root.telRealTimeTableData[index].queueNum}} {{ dialogTitle }} {{ $root.htmlConst.cons_137_call_time }} {{ $root.telRealTimeTableData[index].time }}
					</span> -->
					<span v-if="$root.telRealTimeTableData[index] && $root.telRealTimeTableData[index].time">
						{{$root.htmlConst.cons_331_text_monitor}}
					</span>
					<span v-else style="min-width: 185px;">
						{{ dialogTitle }} {{ $root.htmlConst.cons_136_stop }}
					</span>
				</div>
				<div class="drawer-controls">
					<div class="control-btn" @click="toggleTextDrawerCollapse">
						<i :class="isTextDrawerCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
					</div>
					<div class="control-btn" @click="handleClose">
						<i class="el-icon-close"></i>
					</div>
				</div>
			</div>
		<!-- <hr v-if="!isTextDrawerCollapsed" style="color: #f8f8f8; opacity: 0.5; margin-top: 10px;" /> -->
		<el-row v-if="callEndedAlert" class="call-ended-alert">
			<i class="el-icon-check" style="margin-right: 6px;"></i>モニタリングが終了しました。
		</el-row>
		<!-- Call time -->
		<!-- <div v-if="$root.telRealTimeTableData[index] && $root.telRealTimeTableData[index].time">
			{{ $root.htmlConst.cons_137_call_time }} {{ $root.telRealTimeTableData[index].time }}
		</div> -->
		
		<!-- ========================================== -->
		<!-- 修正日時: 2026-05-08 -->
		<!-- 修正内容: ユーザー情報カード追加（折りたたみ可能） -->
		<!--           - Phone Component のスタイルを参考 -->
		<!--           - お問い合わせ者とオペレーターの情報を1つのel-collapse-itemに配置 -->
		<!-- ========================================== -->
		
		<el-collapse v-if="!isTextDrawerCollapsed" v-model="activeUserInfoCollapse" class="user-info-collapse">
			<el-collapse-item name="userInfo" class="user-info">
				<template slot="title">
					<div class="collapse-title">
						<span>モニタリング中</span>
						<span class="collapse-title__time">{{ $root.htmlConst.cons_137_call_time }}</span>
						<span class="collapse-title__time">{{ ($root.telRealTimeTableData[index] || {}).time }}</span>
					</div>
				</template>
				<!-- Customer 情報 -->
				<div class="on_call_info user_info_margin-right">
					<div class="user_info user_info_margin-right">
						<div class="avatar">
							<el-avatar :size="70" :src="getCustomerLogo() || defaultAvatar">
								<img :src="defaultAvatar" alt="" />
							</el-avatar>
						</div>
						<div class="name">
							<div>{{ getCustomerName(dialogCallerNumber) || '—' }}</div>
						</div>
					</div>
					<div class="call_info">
						<div class="address">
							{{ getCustomerAddress()}}
						</div>
						<div class="call_num">
							{{ dialogCallerNumber}}
						</div>
						<div class="email">
							{{ getCustomerEmail()}}
						</div>
					</div>
				</div>
				<!-- Operator 情報 -->
				<div class="on_call_info operator_call_info">
					<div class="call_info">
						<div class="call_num">{{ getOperatorExtension()}}</div>
						<div class="email">{{ getOperatorEmail()}}</div>
					</div>
					<div class="user_info">
						<div class="avatar">
							<el-avatar :size="70" :src="getOperatorLogo() || defaultAvatar">
								<img :src="defaultAvatar" alt="" />
							</el-avatar>
						</div>
						<div class="name">
							<div>{{ dialogTitle || '—' }}</div>
						</div>
					</div>
				</div>
			</el-collapse-item>
		</el-collapse>
		
		<el-row v-if="!isTextDrawerCollapsed" class="tel-search-input">
				<el-input v-if="search != oldSearch" v-model="search" size="mini"
					:placeholder="$root.htmlConst.cons_140_input" clearable @keyup.enter.native="searchAllText('search')"
					style="width: 75%"></el-input>
				<el-input v-else v-model="search" size="mini" :placeholder="$root.htmlConst.cons_140_input" clearable
					@keyup.enter.native="downSelect()" style="width: 75%"></el-input>
				<span class= "tel-search-btn-group">		
					<el-button v-if="multipleSelection.length" type="info" class="search-nav-btn gray-button" @click="upSelect" icon="el-icon-caret-top"
						style="margin-left: 1%"></el-button>
					<el-button v-else type="info" class="search-nav-btn gray-button" @click="upSelect" icon="el-icon-caret-top" style="margin-left: 1%"
						disabled></el-button>
					<span v-if="search != '' && multipleSelection.length" style="padding: 0 4px">{{ searchIndex }}/{{
						multipleSelection.length }}</span>
					<span v-else-if="search != '' && multipleSelection.length == 0" style="padding: 0 4px">0/0</span>
					<span v-else style="padding: 0 4px">0/0</span>
					<el-button v-if="multipleSelection.length" type="info" class="search-nav-btn gray-button" @click="downSelect"
						icon="el-icon-caret-bottom"></el-button>
					<el-button v-else type="info" class="search-nav-btn gray-button" @click="downSelect" icon="el-icon-caret-bottom" disabled></el-button>
				</span>
			</el-row>
		</div>
		<section class="result-content">
			<el-table :data="allTextData" ref="multipleTable" :show-header="false" v-loading="loading"
				:element-loading-text="$root.htmlConst.cons_141_data_loading" element-loading-spinner="el-icon-loading"
				highlight-current-row>
				<!-- v-chat-scroll (auto scroll) disabled -->
				<template slot="empty">
					<p>{{ emptyText }}</p>
				</template>
				<el-table-column>
					<template slot-scope="scope">
						<div class="message_msg" :class="{
							left: scope.row.flag == 'left',
							right: scope.row.flag == 'right',
						}">
							<!-- 左側: ロゴ -->
							<div class="user_headshot">
								<img :src="scope.row.opLogo != '' ? scope.row.opLogo : require('../../assets/operator.png')"
									v-if="scope.row.user == 'オペレーター'" />
								<!-- ========================================== -->
								<!-- 修正日時: 2026-01-26 -->
								<!-- 修正内容: Watsonと「もっぴー」の時にwatson.gifを表示 -->
								<!--           - require()を使用してwebpackで正しく処理 -->
								<!-- ========================================== -->
								<img :src="require('../../assets/watson.gif')" v-else-if="scope.row.user == 'Watson' || scope.row.user == 'もっぴー'" />
								<img
									:src="scope.row.customerLogo != '' ? scope.row.customerLogo : require('../../assets/user_logo.png')"
									v-else-if="scope.row.user == 'お問い合わせ者'"
									:class="{ 'transformDefaultUserLogo': scope.row.customerLogo == '' }" />
							</div>
							<!-- 右側: ユーザ名 + 吹き出し -->
							<div class="user_msg">
								<div class="speaker" v-if="scope.row.username != ''">{{ scope.row.username }}</div>
								<div class="speaker" v-else>{{ scope.row.user }}</div>
								<div class="user_text" v-html="scope.row.text"></div>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</section>
	</el-drawer>
	<!-- ボイスモニタリング開始確認ダイアログ -->
	<el-dialog :title="$root.htmlConst.cons_145_title_voice" :visible.sync="confirmDialogVisible" width="30%"
		class="tel_dailog">
		<span style="margin: 20px 0 30px 30px; float: left; width: 100%">
			{{ $root.htmlConst.cons_142_start_voice }}
		</span>
		<span slot="footer" class="dialog-footer">
			<el-button class="is-red" type="primary" @click="startMonitoring">
				{{ $root.htmlConst.cons_143_button_ok }}
			</el-button>
			<el-button class="is-blue" type="primary" @click="confirmDialogVisible = false" plain>
				{{ $root.htmlConst.cons_144_button_cancel }}
			</el-button>
		</span>
	</el-dialog>
	<!-- 既存モニタリング停止&新規開始確認ダイアログ -->
	<el-dialog :title="$root.htmlConst.cons_145_title_voice" :visible.sync="startNewMonitoringConfirmDialogVisible"
		width="30%" class="tel_dailog">
		<div style="margin: 20px 30px;">
			{{ $root.htmlConst.cons_309_tel_detail_dialog }}
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button class="is-red" type="primary" @click="startNewMonitoring">
				{{ $root.htmlConst.cons_143_button_ok }}
			</el-button>
			<el-button class="is-blue" type="primary" @click="startNewMonitoringConfirmDialogVisible = false" plain>
				{{ $root.htmlConst.cons_144_button_cancel }}
			</el-button>
		</span>
	</el-dialog>
	<el-row>
		<el-table ref="tableRef" :data="filteredPresenceTableData" border stripe v-loading="loading"
			:element-loading-text="$root.htmlConst.cons_141_data_loading" element-loading-spinner="el-icon-loading"
			:height="$root.presenceTableHeight" style="overflow-y: hidden;width: 100%;" class="presence-table">
			<template slot="empty">
				<p>{{ emptyText }}</p>
			</template>
			<!-- ========================================== -->
			<!-- 修正日時: 2026-01-26 -->
			<!-- 修正内容: お問い合わせ者グループ列追加 -->
			<!--           - callerNumberとcallerNameをグルーピング -->
			<!-- ========================================== -->
			<el-table-column key="customer_group" :label="$root.htmlConst.cons_314_table_header_questioner" :resizable="false">
				<!-- ========================================== -->
				<!-- 修正日時: 2026-01-22 -->
				<!-- 修正内容: 呼出元番号列を追加 -->
				<!--           - ボイスボット（8899）の1対N対応で複数通話を区別するため -->
				<!--           - callerNumberプロパティを表示 -->
				<!-- ========================================== -->
				<el-table-column key="27" prop="callerNumber" :label="$root.htmlConst.cons_315_table_header_caller_num" style="float: left" width="130"
					:resizable="false">
				</el-table-column>
				<!-- ========================================== -->
				<!-- 修正日時: 2026-01-26 -->
				<!-- 修正内容: お問い合わせ者氏名列追加 -->
				<!--           - callerNumberから顧客情報を取得して表示 -->
				<!--           - フィルタリング機能追加 -->
				<!-- ========================================== -->
				<el-table-column key="28" :label="$root.htmlConst.cons_316_table_header_name" width="130" :resizable="false"
					:filters="$root.customerNameFilters" :filter-method="filterCustomerName" filter-placement="bottom-end">
					<template slot-scope="scope">
						<span>{{ getCustomerName(scope.row.callerNumber) }}</span>
					</template>
				</el-table-column>
			</el-table-column>
			<!-- ========================================== -->
			<!-- 修正日時: 2026-01-26 -->
			<!-- 修正内容: エージェントグループ列追加 -->
			<!--           - queueNum、operatorName、role、extensionCallをグルーピング -->
			<!-- ========================================== -->
			<el-table-column key="agent_group" :label="$root.htmlConst.cons_317_table_header_agent_group" :resizable="false">
				<el-table-column key="2" prop="groupName" :label="$root.htmlConst.cons_113_table_header_group"
					style="float: left" :filters="$root.groupFilters" :filter-method="filterGroup"
					filter-placement="bottom-end" width="90" :resizable="false">
				</el-table-column>
				<el-table-column key="19" prop="queueNum" :label="$root.htmlConst.cons_114_table_header_num"
					style="float: left" width="90" :resizable="false">
					<template slot-scope="scope">
						<span >{{ scope.row.queueNum ==='8899' ?scope.row.customizedQueueNum:scope.row.queueNum  }}</span>
					</template>
				</el-table-column>
				<el-table-column key="3" prop="operatorName" :label="$root.htmlConst.cons_316_table_header_name"
					style="float: left" :resizable="false" width="150"
					:filters="$root.operatorNameFilters" :filter-method="filterOperatorName" filter-placement="bottom-end">
				</el-table-column>
				<el-table-column key="20" prop="role" :label="$root.htmlConst.cons_116_table_header_sv"
					:filters="$root.svFilters" :filter-method="filterSV" filter-placement="bottom-end" width="80"
					:resizable="false"></el-table-column>
				<el-table-column key="113" :label="$root.htmlConst.cons_129_table_header_extensioncall" width="110"
					:resizable="false">
					<template slot-scope="scope">
						<el-tooltip placement="top" v-if="scope.row.extensionTo != ''">
							<div slot="content">{{ scope.row.extensionTo }}</div>
							<span style="font-weight:bold">{{ scope.row.extensionCall }}</span>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table-column>
			<el-table-column key="22" prop="model" :label="$root.htmlConst.cons_117_table_header_mode"
				:filters="$root.modelFilters" :filter-method="filterModel" filter-placement="bottom-end" width="100"
				:resizable="false">
			</el-table-column>
			<el-table-column key="4" :label="$root.htmlConst.cons_122_table_header_presence"
				:filters="$root.statusFilters" :filter-method="filterStatus" filter-placement="bottom-end" width="110"
				:resizable="false">
				<template slot-scope="scope">
					<div v-if="scope.row.presence == $root.htmlConst.cons_162_status_out"
						style="background-color: #28a745; color: #fff">{{ scope.row.presence }}</div>
					<div v-else-if="scope.row.presence === $root.htmlConst.cons_163_status_in"
						style="background-color: #67c23a; color: #fff">{{ scope.row.presence }}</div>
					<div v-else-if="scope.row.presence === $root.htmlConst.cons_164_status_f2f"
						style="background-color: #67c23a; color: #fff">{{ scope.row.presence }}</div>
					<div v-else-if="scope.row.presence === $root.htmlConst.cons_165_status_online"
						style="background-color: #007bff; color: #fff">{{ scope.row.presence }}</div>
					<div v-else-if="scope.row.presence === $root.htmlConst.cons_166_status_busy"
						style="background-color: #ffc107">{{ scope.row.presence }}</div>
					<div v-else-if="scope.row.presence === $root.htmlConst.cons_167_status_away"
						style="background-color: #dddddd">{{ scope.row.presence }}</div>
					<div v-else-if="scope.row.presence === $root.htmlConst.cons_168_status_offline"
						style="background-color: #888888; color: #fff">{{ scope.row.presence }}</div>
					<div v-else style="background-color: #67c23a; color: #fff">{{
						scope.row.presence
					}}</div>
				</template>
			</el-table-column>
			<!-- ========================================== -->
			<!-- 修正日時: 2026-01-26 -->
			<!-- 修正内容: 応対時間列追加 -->
			<!--           - TelDetailTableから移植 -->
			<!--           - telRealTimeTableDataから応対時間を取得 -->
			<!-- ========================================== -->
			<el-table-column key="13" :label="$root.htmlConst.cons_318_table_header_elapsed_time" :resizable="false" width="100">
				<template slot-scope="scope">
					<template v-if="getTelDataForRow(scope.row) && scope.row.model == '電話'">
						<div class="alert-long-time" v-if="getTelDataForRow(scope.row).longTimeFlg === 'true'">
							<span>{{ getTelDataForRow(scope.row).time }}</span>
						</div>
						<div v-else>
							<span>{{ getTelDataForRow(scope.row).time || '' }}</span>
						</div>
					</template>
					<span v-else>-</span>
				</template>
			</el-table-column>
			<!-- Show the category tag from the matched real-time call row, following wavView display logic. -->
			<el-table-column class-name="col-category" key="category" :render-header="renderCategoryHeader" width="340" :resizable="false" align="left">
				<template slot-scope="scope">
					<span>{{ getCategoryTagForRow(scope.row) }}</span>
				</template>
			</el-table-column>
			<el-table-column key="26" :label="$root.htmlConst.cons_152_table_header_alert" :resizable="false">
			<!-- ========================================== -->
			<!-- 修正日時: 2026-01-22 -->
			<!-- 修正内容: SVヘルプ列をボイスボット行で非表示化 -->
			<!--           - queueNum !== '8899'の条件を追加 -->
			<!--           - ボイスボットはSVヘルプ機能を使用しないため -->
			<!-- ========================================== -->
			<!-- ========================================== -->
			<!-- 修正日時: 2026-01-26 -->
			<!-- 修正内容: TelDetailTableとのマージ - この列を非表示化 -->
			<!--           - 新しいSVヘルプ列を別途追加するため -->
			<!-- ========================================== -->
			<el-table-column v-if="false" key="10" :label="$root.htmlConst.cons_122_table_header_help" :resizable="false"
				width="80">
				<template slot-scope="scope">
					<div v-if="scope.row.queueNum !== '8899' && scope.row.svhelpStatus != ''"
						style="background-color: #dcc9f4; color: #000;">
						<span>{{ scope.row.svhelpRequestCount }}</span>
					</div>
				</template>
			</el-table-column>
			  <!-- 要注意 -->
				<el-table-column key="11" :label="$root.htmlConst.cons_311_table_header_warning" :resizable="false"
					width="80">
					<template slot-scope="scope" v-if="getTelDataForRow(scope.row)">
						<!-- 2026-03-11 get warning word info from warning_word_history, instead of Ng word -->
						<!-- <el-tooltip placement="top" v-if="scope.row.ngWordCount != 0">
							<div slot="content">{{ getNgWordTextForRow(scope.row) || '—' }}</div>
							<div
								style="background-color: #ff9a91; color: red; float: left; width: 100%">
								<span>{{ scope.row.ngWordCount }}</span>
							</div>
						</el-tooltip> -->
						<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).telWarningFlg && getTelDataForRow(scope.row).telWarningFlg === 'true'">
							<div slot="content">{{ getTelDataForRow(scope.row).telWarningWords || '—' }}</div>
							<div
								class="alert-warning-word">
								<span>{{ getTelDataForRow(scope.row).telWarningWordCount }}</span>
							</div>
						</el-tooltip>
						<div v-else style="color: #000">
							<span></span>
						</div>
					</template>
				</el-table-column>
				<!-- 緊急（データは暫定ブランク） -->
				<!-- 2026/03/04 remove [緊急] column -->
				<!-- <el-table-column key="urgent" :label="$root.htmlConst.cons_312_table_header_urgent" :resizable="false" width="80">
					<template>
						<div style="color: #000">
							<span></span>
						</div>
					</template>
				</el-table-column> -->
			<el-table-column key="12" :label="$root.htmlConst.cons_213_long_time_header" :resizable="false"
				width="80">
				<template slot-scope="scope">
					<div class="alert-long-time" v-if="scope.row.longTimeFlg === 'true'">
						<span>{{ formatCount(scope.row.longTimeCount) }}</span>
					</div>
					<div v-else>
						<span></span>
					</div>
				</template>
			</el-table-column>
			<!-- ========================================== -->
			<!-- 修正日時: 2026-01-26 -->
			<!-- 修正内容: 低評価列追加 -->
			<!--           - 長時間アラート列の右に追加 -->
			<!--           - データは暫定ブランク -->
			<!-- ========================================== -->
			<!-- 2026/03/04 remove [低評価] column  -->
			<!-- <el-table-column key="13" :label="$root.htmlConst.cons_310_evaluation_header" :resizable="false" width="80">
				<template>
					<div style="color: #000">
						<span></span>
					</div>
				</template>
			</el-table-column> -->
		</el-table-column>
		<!-- ========================================== -->
		<!-- 修正日時: 2026-01-26 -->
		<!-- 修正内容: TelDetailTableとのマージ - 新しい列追加 -->
		<!--           - モニタリング列（ボイス、テキスト） -->
		<!--           - SVヘルプ関連列（依頼、サポート） -->
		<!--           - 評価ワード発生回数列 -->
		<!-- ========================================== -->
		<!-- モニタリング列 -->
		<el-table-column key="5" :label="$root.htmlConst.cons_119_table_header_monitor" :resizable="false" v-if="$root.user.role === 'supervisor'">
			<!-- ボイス -->
			<el-table-column :label="$root.htmlConst.cons_120_table_header_voice" width="60" :resizable="false">
				<template slot-scope="scope">
					<template v-if="getTelDataForRow(scope.row) && scope.row.model == '電話'">
						<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).monitoring === true">
							<div slot="content">{{ getTelDataForRow(scope.row).monitorName }}</div>
							<el-button type="primary" v-if="getTelDataForRow(scope.row).monitoring === true" icon="el-icon-phone-outline"
								@click="handleStartMonitoringClick(scope.row)" class="tel-monitoring"
								:disabled="userInCall"></el-button>
						</el-tooltip>
						<el-button type="primary" v-else-if="getTelDataForRow(scope.row).monitoring === false" icon="el-icon-phone"
							@click="handleStartMonitoringClick(scope.row)" :disabled="userInCall"></el-button>
						<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).monitoring === true && checkUserMonitor(getTelDataForRow(scope.row))">
							<div slot="content">モニタリングを終了</div>
							<el-button type="danger" v-if="getTelDataForRow(scope.row).monitoring === true && checkUserMonitor(getTelDataForRow(scope.row))"
								icon="el-icon-phone" @click="endMonitoring(getTelDataForRow(scope.row))"></el-button>
						</el-tooltip>
					</template>
				</template>
			</el-table-column>
			<!-- テキスト -->
			<el-table-column key="6" :label="$root.htmlConst.cons_121_table_header_text" width="80" :resizable="false">
				<template slot-scope="scope">
					<template v-if="getTelDataForRow(scope.row) && scope.row.model == '電話'">
						<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).hasSVNameFlag === true">
							<div slot="content">{{ getTelDataForRow(scope.row).svName }}</div>
							<el-button type="primary" v-if="getTelDataForRow(scope.row).hasSVNameFlag === true" icon="el-icon-document"
								@click="viewAllText(filteredPresenceTableData.indexOf(scope.row), scope.row)"></el-button>
						</el-tooltip>
						<el-button type="primary" v-else-if="getTelDataForRow(scope.row).hasSVNameFlag === false" icon="el-icon-document"
							@click="viewAllText(filteredPresenceTableData.indexOf(scope.row), scope.row)"
							style="background-color: #409eff; border-color: #409eff"></el-button>
					</template>
				</template>
			</el-table-column>
		</el-table-column>
		<!-- モニタリング列（オペレーター用） -->
		<el-table-column :label="$root.htmlConst.cons_119_table_header_monitor" :resizable="false" v-else-if="$root.user.role === 'operator'">
			<!-- ボイス -->
			<el-table-column key="5" :resizable="false" :label="$root.htmlConst.cons_120_table_header_voice" width="60">
				<template slot-scope="scope">
					<template v-if="getTelDataForRow(scope.row) && scope.row.model == '電話'">
						<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).monitoring === true">
							<div slot="content">{{ getTelDataForRow(scope.row).monitorName }}</div>
							<el-button type="primary" v-if="getTelDataForRow(scope.row).monitoring === true" icon="el-icon-phone-outline"
								disabled></el-button>
						</el-tooltip>
						<el-button type="primary" v-else-if="getTelDataForRow(scope.row).monitoring === false" icon="el-icon-phone"
							style="background-color: #bbb; border-color: #bbb" disabled></el-button>
					</template>
				</template>
			</el-table-column>
			<!-- テキスト -->
			<el-table-column key="6" :resizable="false" :label="$root.htmlConst.cons_121_table_header_text" width="60">
				<template slot-scope="scope">
					<template v-if="getTelDataForRow(scope.row) && scope.row.model == '電話'">
						<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).hasSVNameFlag === true">
							<div slot="content">{{ getTelDataForRow(scope.row).svName }}</div>
							<el-button type="primary" v-if="getTelDataForRow(scope.row).hasSVNameFlag === true" icon="el-icon-document"
								disabled></el-button>
						</el-tooltip>
						<el-button type="primary" v-else-if="getTelDataForRow(scope.row).hasSVNameFlag === false" icon="el-icon-document"
							style="background-color: #bbb; border-color: #bbb" disabled></el-button>
					</template>
				</template>
			</el-table-column>
		</el-table-column>
		<!-- SVヘルプ列 -->
		<el-table-column key="21" prop="svHelp" :label="$root.htmlConst.cons_122_table_header_help" :resizable="false">
			<!-- 依頼カウント -->
			<el-table-column key="99" :label="$root.htmlConst.cons_122_table_header_dependent" width="80" :resizable="false">
				<template slot-scope="scope">
					<div v-if="getTelDataForRow(scope.row) && getTelDataForRow(scope.row).svhelpStatus"
						:style="{ 'background-color': '#dcc9f4', color: '#000' }">
						<span>{{ getTelDataForRow(scope.row).svhelpRequestCount }}</span>
					</div>
				</template>
			</el-table-column>
			<!-- サポートボタン -->
			<el-table-column key="98" width="140" :label="$root.htmlConst.cons_122_table_header_support" :resizable="false">
				<template slot-scope="scope">
					<template v-if="getTelDataForRow(scope.row)">
						<el-button class="sup_btn" type="primary"
							v-if="getTelDataForRow(scope.row).svhelpStatus == 'request' && $root.user.role === 'supervisor' && getTelDataForRow(scope.row).svhelpStatus != 'onSupport'"
							icon="el-icon-s-custom" @click="svHelpClick(scope.row)">サポート必要</el-button>
						<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).svhelpStatus == 'onSupport'">
							<div slot="content">{{ getTelDataForRow(scope.row).svhelperString }}</div>
							<el-button class="sup_btn" plain v-if="svSupportResetButtonVisible(getTelDataForRow(scope.row))"
								@click="resetSvHelpClick(scope.row)"> <img :src="sup_icon1" alt=""> サポート中</el-button>
							<el-button class="sup_btn" plain
								v-if="svSupportDisabledButtonVisible(getTelDataForRow(scope.row))"
								disabled> <img :src="sup_icon1" alt=""> サポート中</el-button>
						</el-tooltip>
						<el-button class="sup_btn" type="primary" v-if="getTelDataForRow(scope.row).svhelpStatus == '' && getTelDataForRow(scope.row).role === '' && scope.row.queueNum !== '8899'"
							icon="el-icon-s-custom"
							style="background-color: #bbbbbb; border-color: #bbbbbb; cursor: no-drop">サポート不要</el-button>
						<el-button class="sup_btn" type="primary"
							v-if="getTelDataForRow(scope.row).svhelpStatus == 'request' && $root.user.role === 'operator'" icon="el-icon-s-custom"
							style="background-color: #bbbbbb; border-color: #bbbbbb; cursor: no-drop">サポート必要</el-button>
					</template>
				</template>
			</el-table-column>
		</el-table-column>
		<!-- ========================================== -->
		<!-- 修正日時: 2026-03-05 -->
		<!-- 修正内容: add ポジネガ度列 -->
		<!-- ========================================== -->
		<!-- ポジネガ度列-->
		<el-table-column key="29" prop="pnDegree" :label="$root.htmlConst.cons_328_table_header_pn_degree"
				style="float: left" 
				filter-placement="bottom-end" width="90" :resizable="false">
		</el-table-column>

		<!-- ========================================== -->
		<!-- 修正日時: 2026-01-26 -->
		<!-- 修正内容: 評価ワード発生回数列の構造変更 -->
		<!--           - ワードタイプ（Wow/NG/NGマナー）から発話者（Customer/Agent）でグループ化 -->
		<!--           - Customer: Wowワード、NGワード -->
		<!--           - Agent: Wowワード、NGワード、NGマナー -->
		<!-- ========================================== -->
		<!-- 評価ワード発生回数列 -->
		<el-table-column key="27" :label="$root.htmlConst.cons_152_table_header_word_count" :resizable="false">
			<!-- Customer -->
			<el-table-column key="customer_words" :label="$root.htmlConst.cons_124_table_header_questioner" :resizable="false">
				<!-- Wowワード -->
				<el-table-column key="28" :label="$root.htmlConst.cons_151_table_header_wowword" width="100" :resizable="false">
					<template slot-scope="scope">
						<template v-if="getTelDataForRow(scope.row)">
							<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).telQuestionerWowFlg === 'true'">
								<div slot="content">{{ getTelDataForRow(scope.row).telQuestionerWowWords }}</div>
								<div class="alert-wow-word">
									<span>{{ formatCount(getTelDataForRow(scope.row).telQuestionerWowWordCount) }}</span>
								</div>
							</el-tooltip>
							<!-- <div style="color: #000" v-else> -->
							<div v-else :style="(Number(getTelDataForRow(scope.row).telQuestionerWowWordCount) || 0) > 0 ? 'background-color: #67c23a;color: #000; float: left; width: 100%;' : 'color: #000'">
								<span>{{ formatCount(getTelDataForRow(scope.row).telQuestionerWowWordCount) }}</span>
							</div>
						</template>
					</template>
				</el-table-column>
				<!-- NGワード -->
				<el-table-column key="10" :label="$root.htmlConst.cons_126_table_header_ngword" width="100" :resizable="false">
					<template slot-scope="scope">
						<template v-if="getTelDataForRow(scope.row)">
							<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).telQuestionerNgFlg === 'true'">
								<div slot="content">{{ getTelDataForRow(scope.row).telQuestionerNgWords }}</div>
								<div class="alert-ng-word">
									<span>{{ formatCount(getTelDataForRow(scope.row).telQuestionerNgWordCount) }}</span>
								</div>
							</el-tooltip>
							<div style="color: #000" v-else>
								<span>{{ formatCount(getTelDataForRow(scope.row).telQuestionerNgWordCount) }}</span>
							</div>
						</template>
					</template>
				</el-table-column>
			</el-table-column>
			<!-- Agent -->
			<el-table-column key="agent_words" :label="$root.htmlConst.cons_125_table_header_operator" :resizable="false">
				<!-- Wowワード 20260304 remove column [Wowワード]-->
				<!-- <el-table-column key="39" :label="$root.htmlConst.cons_151_table_header_wowword" width="100" :resizable="false">
					<template slot-scope="scope">
						<template v-if="getTelDataForRow(scope.row)">
							<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).telOperatorWowWordFlg === 'true'">
								<div slot="content">{{ getTelDataForRow(scope.row).telOperatorWowWords }}</div>
								<div style="background-color: #67c23a; color: #000; float: left; width: 100%;">
									<span>{{ formatCount(getTelDataForRow(scope.row).telOperatorWowWordCount) }}</span>
								</div>
							</el-tooltip>
							<div v-else :style="(Number(getTelDataForRow(scope.row).telOperatorWowWordCount) || 0) > 0 ? 'background-color: #67c23a; color: #000; float: left; width: 100%;' : 'color: #000'">
								<span>{{ formatCount(getTelDataForRow(scope.row).telOperatorWowWordCount) }}</span>
							</div>
						</template>
					</template>
				</el-table-column> -->
				<!-- NGマナー -->
				<el-table-column key="11" :label="$root.htmlConst.cons_150_table_header_ngmanner" width="100" :resizable="false">
					<template slot-scope="scope">
						<template v-if="getTelDataForRow(scope.row)">
							<el-tooltip placement="top" v-if="getTelDataForRow(scope.row).telOperatorNgFlg === 'true'">
								<div slot="content">{{ getTelDataForRow(scope.row).telOperatortelOperatorNgManners}}</div>
								<div class="alert-ng-manner">
									<span>{{ formatCount(getTelDataForRow(scope.row).telOperatorrNgMannerCount) }}</span>
								</div>
							</el-tooltip>
							<div style="color: #000" v-else>
								<span>{{ formatCount(getTelDataForRow(scope.row).telOperatorrNgMannerCount) }}</span>
							</div>
						</template>
					</template>
				</el-table-column>
			</el-table-column>
		</el-table-column>
		<!-- ========================================== -->
		<!-- 修正日時: 2026-01-26 -->
		<!-- 修正内容: TelDetailTableとのマージ - この列を非表示化 -->
		<!-- ========================================== -->
		<el-table-column v-if="false" key="119" :label="$root.htmlConst.cons_129_table_header_suppport" width="130"
			:resizable="false">
			<template slot-scope="scope">
				<el-button class="sup_btn" type="primary"
					v-if="scope.row.svhelpStatus == 'request' && $root.user.role === 'supervisor' && scope.row.svhelpStatus != 'onSupport'"
					icon="el-icon-s-custom" @click="svHelpClick(scope.row)">サポート必要</el-button>
				<el-tooltip placement="top" v-if="scope.row.svhelpStatus == 'onSupport'">
					<div slot="content">{{ scope.row.svhelperString }}</div>
					<el-button class="sup_btn" plain style="cursor: no-drop"> <img :src="sup_icon1" alt="">
						サポート中</el-button>
				</el-tooltip>
				<el-button class="sup_btn" type="primary" v-if="scope.row.svhelpStatus == ''"
					icon="el-icon-s-custom"
					style="background-color: #bbbbbb; border-color: #bbbbbb; cursor: no-drop">サポート不要{{
						scope.row.svhelpStatus }}</el-button>
				<el-button class="sup_btn" type="primary"
					v-if="$root.user.role !== 'supervisor' && scope.row.svhelpStatus == 'request'"
					icon="el-icon-s-custom"
					style="background-color: #bbbbbb; border-color: #bbbbbb; cursor: no-drop">サポート必要</el-button>
			</template>
		</el-table-column>
		<!-- ========================================== -->
		<!-- 修正日時: 2026-01-26 -->
		<!-- 修正内容: TelDetailTableとのマージ - この列を非表示化 -->
		<!-- ========================================== -->
		<el-table-column v-if="false" key="129" :label="$root.htmlConst.cons_129_table_header_detail" style="float: left"
			width="85" :resizable="false">
			<template slot-scope="scope">
				<el-button v-if="scope.row.presence.includes('応対中')" type="primary" icon="el-icon-view"
					@click="goToDetail(scope.row.model)"></el-button>
				<el-button v-else type="primary" class="sup_btn2" disabled><img class="sup_icon" :src="sup_icon2"
						alt=""></el-button>
			</template>
		</el-table-column>
		</el-table>
	</el-row>
	</div>
</template>

<script>
import api from "@/api";
import { find } from "lodash";
// import data1 from './1.json'
// import data2 from './2.json'
var moment = require("moment-timezone");
var sd = require("silly-datetime");
export default {
	name: "PresenceDetailTable",
	data() {
		return {
			sup_icon1: require('@/assets/sup_icon1.svg'),
			sup_icon2: require('@/assets/sup_icon2.svg'),
			emptyText: "",
			lockReconnect: false,
			allTextData: [],
			dialogTitle: "",
			dialogVisible: false,
			confirmDialogVisible: false,
			conUuid: "",
			search: "",
			oldSearch: "",
			loading: this.loading,
			dialogOperatorId: "",
			userTextInterval: "",
			dialogTime: "",
			index: "",
			checkIndex: 0,
			searchIndex: 1,
			multipleSelection: [],
			// ==========================================
			// 修正日時: 2026-01-26
			// 修正内容: テキストモニタリングダイアログ用の電話番号保存
			//           - お問い合わせ者の氏名とロゴを表示するため
			// ==========================================
			dialogCallerNumber: "",
			// ==========================================
			// 修正日時: 2026-01-26
			// 修正内容: TelDetailTableとのマージ - モニタリング機能用データ追加
			//           - TelDetailTableから移植したモニタリング関連の状態管理
			// ==========================================
			isMonitoring: false,
			currentRowMonitoring: {},
			currentRowClicked: {},
			startNewMonitoringConfirmDialogVisible: false,
			isCreateThreeCallSubmit: true,
			// ==========================================
			// 修正日時: 2026-01-26
			// 修正内容: お問い合わせ者氏名の取得用
			//           - callerNumberをキーに顧客情報をキャッシュ
			// ==========================================
			customerNameCache: {},
			customerInfoCache: {},
			// 通話中のみtelRealTimeTableDetailをポーリングするためのタイマー
			telRealtimePollTimer: null,
			// テキストモニタリング中に通話終了した時の通知フラグ
			callEndedAlert: false,
			// 現在モニタリング中のダイヤル番号（555+xxx）
			monitoringDialNum: '',
			// ==========================================
			// 修正日時: 2026-04-02
			// 修正内容: キーワードハイライト機能追加
			//           - wavViewからハイライト機能を移植
			//           - 要注意/NG/Wow/NGマナーワードをハイライト表示
			// ==========================================
			wordArr: [],
			questioner: 'お問い合わせ者',
			// ==========================================
			// Modified: 2026-04-30
			// Change: Add collapse state for text monitoring drawer
			//         - Similar to Phone component collapse feature
			// ==========================================
			isTextDrawerCollapsed: false,
			// ==========================================
			// 修正日時: 2026-05-08
			// 修正内容: ユーザー情報カード用のデフォルトアバター
			// ==========================================
			defaultAvatar: require('@/assets/user_logo.png'),
			// ==========================================
			// 修正日時: 2026-05-08
			// 修正内容: ユーザー情報の折りたたみ状態管理（デフォルトで展開）
			// ==========================================
			activeUserInfoCollapse: ['userInfo'],
			voicebotAvatar:require('@/assets/img/ai_voicebot.png')
		};
	},
	// ==========================================
	// 修正日時: 2026-01-22
	// 修正内容: 応対不可ステータスの除外機能追加
	//           - .envの設定（VUE_APP_EXCLUDE_OFFLINE_STATUS）で除外制御
	//           - テーブル表示データから応対不可を除外するcomputedプロパティ
	// ==========================================
	computed: {
		textDrawerOffset() {
			return this.$store.getters['drawer/getDrawerOffset']('text');
		},
		textDrawerZIndex() {
			return this.$store.getters['drawer/getDrawerZIndex']('text');
		},
		textDrawerClass() {
			const baseClass = this.isTextDrawerCollapsed 
				? 'text-monitoring-drawer text-monitoring-drawer--collapsed' 
				: 'text-monitoring-drawer';
			return baseClass;
		},
		filteredPresenceTableData() {
			const hc = this.$root.htmlConst;
			if (
				!this.$root.presenceTableData ||
				!hc ||
				typeof hc !== 'object' ||
				Array.isArray(hc)
			) {
				return [];
			}
			// .envの設定で除外するかどうかを制御
			const excludeOffline = process.env.VUE_APP_EXCLUDE_OFFLINE_STATUS !== 'false';
			if (!excludeOffline) {
				return this.$root.presenceTableData;
			}
			const offlineStatus = this.$root.htmlConst.cons_168_status_offline;
			if (offlineStatus === undefined) {
				return this.$root.presenceTableData;
			}
			return this.$root.presenceTableData.filter(
				(item) => item.presence !== offlineStatus
			);
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - userInCall computed追加
		//           - ユーザーが通話中かどうかを判定
		// ==========================================
		userInCall() {
			if (this.$root.telRealTimeTableData) {
				for (let oneCallInfo of this.$root.telRealTimeTableData) {
					if (oneCallInfo.loginId == this.$root.user.login_id && !oneCallInfo.isChanspy) {
						return true
					}
				}
			}
			return false
		}
	},
	created() {
		var _this = this;
		this.loading = true;
		this.$root.isDataLoading = true
		api.getUC3config().then(
			(res) => {
				if (res && res.data) {
					let data = res.data;
					_this.$root.nameless = data.nameless;
					_this.$root.dailySatisfactionIndex = data.dailySatisfactionIndex;
					_this.$root.dailyTimeFlg = data.dailyTimeFlg;

					if (_this.$root.user.user_id) {
						api.changeDashboardType(_this.$root.user.user_id, "ALL").then(
							(res) => {
								if (res && res.data) {
									_this.getTableDetail();
								}
							},
							(err) => {
								console.log(err);
							}
						);
					} else {
						api.getUserInfo().then(
							(res) => {
								if (res && res.data) {
									let data = res.data;
									_this.$root.user = data.user;
									api.changeDashboardType(_this.$root.user.user_id, "ALL").then(
										(res) => {
											if (res && res.data) {
												_this.getTableDetail();
											}
										},
										(err) => {
											console.log(err);
										}
									);
								}
							},
							(err) => {
								console.log(err);
							}
						);
					}
				}
			},
			(err) => {
				console.log(err);
			}
		);
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - 初回データ取得
		//           - telRealTimeTableDataを初回ロード時に取得
		// ==========================================
		if (_this.$root.user && _this.$root.user.user_id) {
			api.getTelRealTimeTableDetail(_this.$root.user.user_id).then(
				(res) => {
					if (res && res.data) {
						_this.$root.telRealTimeTableData = res.data.output_list;
					}
				},
				(err) => {
					console.log(err);
				}
			);
		}
	},
	mounted: function () {
		// ==========================================
		// Modified: 2026-04-30
		// Change: Add body class for drawer background click control
		//         - Allow background interaction when drawer is open
		// ==========================================
		document.body.classList.add('text-drawer-allow-back-clicks');

		var _this = this;
		this.timer = setInterval(function () {
			// ==========================================
			// 修正日時: 2026-01-22
			// 修正内容: プレゼンステーブルの長時間アラート計算のタイムゾーン統一
			//           - JST手動計算とmoment().diff()を削除し、UTCベースで統一
			//           - longTimeCountの初期化を数値（0）に変更（空文字列から）
			//           - バックエンドと同じ計算ロジックを使用
			// ==========================================
			for (let data of _this.$root.presenceTableData) {
				if (data.answerTime) {
					// UTCベースで時間差を計算（バックエンドと同じロジック）
					let nowDate = new Date().getTime(); // UTC
					let answerTimeDate = new Date(data.answerTime).getTime(); // UTC（ISO文字列をパース）
					let diffTime = nowDate - answerTimeDate; // ミリ秒
					let hours = Math.floor(diffTime / (3600 * 1000));
					let minutes = Math.floor((diffTime - hours * 3600 * 1000) / (60 * 1000));
					
					// longTimeCountが未初期化の場合は0に設定
					if (data.longTimeCount === "" || data.longTimeCount === undefined) {
						data.longTimeCount = 0;
					}
					
					if (data.model == "電話") {
						if (
							data.longTimeFlg != "true" && diffTime > 0 &&
							(hours > 0 || minutes >= _this.$root.longTimeConfig)
						) {
							data.longTimeFlg = "true";
							data.longTimeCount++;
						}
					}
				}
			}
			// ==========================================
			// 修正日時: 2026-01-26
			// 修正内容: 経過時間の自動カウント機能追加
			//           - TelDetailTableから移植
			//           - telRealTimeTableDataの時間を1秒ごとに更新
			// ==========================================
			if (_this.$root.telRealTimeTableData) {
				for (let data of _this.$root.telRealTimeTableData) {
					if (data.answerTime) {
						// バックエンドのcaculateTime()と同じロジックを使用（UTCで統一）
						// answerTimeはISO文字列（UTC）として受け取る
						let nowDate = new Date().getTime(); // UTC
						let answerTimeDate = new Date(data.answerTime).getTime(); // UTC（ISO文字列をパース）
						let diffTime = nowDate - answerTimeDate;

						// 時間、分、秒を計算（Math.floorを使用）
						let hours = Math.floor(diffTime / (3600 * 1000));
						let minutes = Math.floor((diffTime - hours * 3600 * 1000) / (60 * 1000));
						let seconds = Math.floor((diffTime - hours * 3600 * 1000 - minutes * 60 * 1000) / 1000);

						// フォーマット（バックエンドと同じ形式）
						let hoursStr = hours < 10 ? ("0" + hours + ":") : (hours + ":");
						let minutesStr = minutes < 10 ? ("0" + minutes + ":") : (minutes + ":");
						let secondsStr = seconds < 10 ? ("0" + seconds) : (seconds);

						data.time = hoursStr + minutesStr + secondsStr;

						// 長時間フラグの判定
						if (
							data.longTimeFlg != "true" && diffTime > 0 && 
							(hours > 0 || minutes >= _this.$root.longTimeConfig)
						) {
							data.longTimeFlg = "true";
						}
					}
				}
				_this.$root.telLongTimeCount = _this.$root.telRealTimeTableData.filter((i) => {
					return i.hasOwnProperty("longTimeFlg") && i.longTimeFlg == "true";
				}).length;
			}
		let presenceLongTimeRows = _this.$root.presenceTableData.filter((i) => {
			return i.model == "電話" && i.hasOwnProperty("longTimeFlg") && i.longTimeFlg == "true";
		});
		// ボイスボットと通常オペレーターを分けて処理
		let presenceLongTimePersons = presenceLongTimeRows.map((i) => {
			// ボイスボット（queueNum === '8899'）の場合は呼び出し元番号でユニーク化
			if (i.queueNum === '8899') {
				return 'voicebot_' + i.callerNumber;
			}
			// 通常のオペレーターはloginIdでユニーク化
			return 'operator_' + i.loginId;
		})
		let persons = [...new Set(presenceLongTimePersons)]
		_this.$root.presenceLongTimeCount = persons.length;

			_this.$nextTick(() => {
				_this.$refs.tableRef.doLayout();
			});
		}, 1000);

		// ==========================================
		// 修正日時: 2026-03-12
		// 修正内容: 暫定対応、通話中のみ3秒おきにgetTelRealTimeTableDetailをポーリング
		//           - NG/Warningワードなどリアルタイム情報を更新するため、クラウドで実行する際は当該処理不要
		// ==========================================
		this.telRealtimePollTimer = setInterval(() => {
			try {
				// 通話が存在する場合のみAPIを呼び出す
				if (
					this.$root &&
					this.$root.user &&
					this.$root.user.user_id &&
					this.$root.telRealTimeTableData &&
					this.$root.telRealTimeTableData.length > 0
				) {
					api.getTelRealTimeTableDetail(this.$root.user.user_id).then(
						(res) => {
							if (res && res.data) {
								const newList = res.data.output_list || [];
								const oldList = this.$root.telRealTimeTableData || [];
								// 応対時間は1秒タイマーで更新しているため、API結果では上書きせず既存値を維持
								newList.forEach((row) => {
									const match = oldList.find((old) => {
										if (row.queueNum === '8899') {
											return old.callerNumber === row.callerNumber;
										}
										return old.loginId === row.loginId;
									});
									if (match) {
										row.time = match.time;
										row.longTimeFlg = match.longTimeFlg;
									}
								});
								this.$root.telRealTimeTableData = newList;
							}
						},
						(err) => {
							console.log(err);
						}
					);
				}
			} catch (e) {
				console.log(e);
			}
		}, 3000);
	},
	watch: {
		"$store.state.phone.lineList": function(newLineList) {
			if (!this.monitoringDialNum) return;
			const stillInCall = newLineList && newLineList.some(
				(line) => line.LineNumber === this.monitoringDialNum
			);
			if (!stillInCall) {
				this.monitoringDialNum = '';
				// this.$message.success('モニタリングが終了しました。');
			}
		},
		"$root.telRealTimeTableData": function(newList) {
			if (!this.dialogVisible || !this.dialogOperatorId) return;
			const telRow = this.$root.telRealTimeTableData[this.index];
			const stillInCall = newList && newList.some((row) => {
				if (telRow && telRow.queueNum === '8899') {
					return row.callerNumber === (telRow && telRow.callerNumber);
				}
				return row.loginId === this.dialogOperatorId;
			});
			if (!stillInCall && !this.callEndedAlert) {
				this.callEndedAlert = true;
				clearInterval(this.userTextInterval);
			}
		},
		dialogVisible(val) {
			if (val) {
				this.callEndedAlert = false;
			}
			// Update drawer order in Vuex
			this.$store.commit('drawer/updateDrawerOrder', { 
				drawerType: 'text', 
				isOpen: val 
			});
			
			if (val) {
				document.body.classList.add('text-drawer-allow-back-clicks');
			} else {
				document.body.classList.remove('text-drawer-allow-back-clicks');
			}
			
		},
	},
	beforeDestroy: function () {
		// ==========================================
		// Modified: 2026-04-30
		// Change: Remove body class for drawer background click control
		//         - Clean up when component is destroyed
		// ==========================================
		document.body.classList.remove('text-drawer-allow-back-clicks');
		
		if (this.timer) {
			clearInterval(this.timer);
		}
		if (this.telRealtimePollTimer) {
			clearInterval(this.telRealtimePollTimer);
			this.telRealtimePollTimer = null;
		}
	},
	methods: {
		// ==========================================
		// Modified: 2026-04-30
		// Change: Add toggle method for text monitoring drawer collapse
		//         - Similar to Phone component collapse feature
		// ==========================================
		toggleTextDrawerCollapse() {
			this.isTextDrawerCollapsed = !this.isTextDrawerCollapsed;
		},
		/** 0の場合はブランク、それ以外はそのまま表示 */
		formatCount(val) {
			return (val || 0) ? val : '';
		},
		svHelpClick(row) {
			api
				.svhelpOnSupport(
					"NEXMO_ASTERISK_PBX_MODE",
					row.operatorId,
					this.$root.user.user_id,
					""
				)
				.then(
					(res) => {
						if (res && res.data) {
							console.log("svhelpOnSupport success");
						}
					},
					(err) => {
						console.log(err);
					}
				);
		},
		goToDetail(mode) {
			if (mode == "チャット") {
				this.$root.fontColor = "#125478";
				this.$root.headerColor = "#94E3FF";
				api
					.changeDashboardType(this.$root.user.user_id, "MANUAL_CHAT_MODE")
					.then(
						(res) => {
							if (res && res.data) {
								this.$root.activeName = "chat";
								this.$root.unusedChartChatList = [];
								this.$root.usedChartChatList = [
									{
										name: "ChatPersonStatusChart",
										displayName: "応対稼働状況 - のべ人",
									},
									{
										name: "ChatStatusChart",
										displayName: "応対稼働状況 - 人",
									},
									{
										name: "ChatAnswerStatusChart",
										displayName: "応対ステータス状況",
									},
									{
										name: "ChatNgWordsAlertCount",
										displayName: this.$root.htmlConst.cons_105_ngword_header,
									},
									{
										name: "ChatSupervisorHelpAlertCount",
										displayName: this.$root.htmlConst.cons_107_sv_header,
									},
								];
								if (localStorage.getItem('usedChartChatList')) {
									let localConfig = JSON.parse(localStorage.getItem('usedChartChatList'))
									this.$root.unusedChartChatList = this.$root.usedChartChatList.filter(item => localConfig.filter(ele => ele.name == item.name).length == 0)
									this.$root.usedChartChatList = this.$root.usedChartChatList.filter(item => localConfig.filter(ele => ele.name == item.name).length > 0)
								}
							}
						},
						(err) => {
							console.log(err);
						}
					);
			} else if (mode == "電話") {
				this.$root.fontColor = "#fff";
				this.$root.headerColor = "#55BFE7";
				api
					.changeDashboardType(
						this.$root.user.user_id,
						"NEXMO_ASTERISK_PBX_MODE"
					)
					.then(
						(res) => {
							if (res && res.data) {
								this.$root.activeName = "tel";
								if (this.$root.nameless == "display") {
									this.$root.unusedChartTelList = [];
									this.$root.usedChartTelList = [
										{
											name: "TelStatusChart",
											displayName: this.$root.htmlConst.cons_103_tel_header,
										},
										{
											name: "TelReleaseStatusChart",
											displayName: this.$root.htmlConst.cons_104_abandon_header,
										},
										{
											name: "TelNgWordsAlertCount",
											displayName: this.$root.htmlConst.cons_105_ngword_header,
										},
										{
											name: "TelLongTimeAlertCount",
											displayName: this.$root.htmlConst
												.cons_106_longtime_header,
										},
										{
											name: "TelSupervisorHelpAlertCount",
											displayName: this.$root.htmlConst.cons_107_sv_header,
										},
									];
								} else {
									this.$root.unusedChartTelList = [
										{
											name: "PersonConfirmAlertCount",
											displayName: this.$root.htmlConst
												.cons_109_annoyances_header,
										},
									];
									this.$root.usedChartTelList = [
										{
											name: "TelStatusChart",
											displayName: this.$root.htmlConst.cons_103_tel_header,
										},
										{
											name: "TelReleaseStatusChart",
											displayName: this.$root.htmlConst.cons_104_abandon_header,
										},
										{
											name: "TelNgWordsAlertCount",
											displayName: this.$root.htmlConst.cons_105_ngword_header,
										},
										{
											name: "TelLongTimeAlertCount",
											displayName: this.$root.htmlConst
												.cons_106_longtime_header,
										},
										{
											name: "TelSupervisorHelpAlertCount",
											displayName: this.$root.htmlConst.cons_107_sv_header,
										},
									];
								}
								if (localStorage.getItem('usedChartTelList')) {
									let localConfig = JSON.parse(localStorage.getItem('usedChartTelList'))
									this.$root.unusedChartTelList = this.$root.usedChartTelList.filter(item => localConfig.filter(ele => ele.name == item.name).length == 0)
									this.$root.usedChartTelList = this.$root.usedChartTelList.filter(item => localConfig.filter(ele => ele.name == item.name).length > 0)
								}
							}
						},
						(err) => {
							console.log(err);
						}
					);
			} else {
				this.$root.fontColor = "#fff";
				this.$root.headerColor = "#0086B5";
				api.changeDashboardType(this.$root.user.user_id, "STAND_MIC_MODE").then(
					(res) => {
						if (res && res.data) {
							this.$root.activeName = "f2f";
							this.$root.unusedChartF2FList = [];
							this.$root.usedChartF2FList = [
								{
									name: "F2FStatusChart",
									displayName: this.$root.htmlConst.cons_102_f2f_header,
								},
								{
									name: "F2FNgWordsAlertCount",
									displayName: this.$root.htmlConst.cons_105_ngword_header,
								},
								{
									name: "F2FSupervisorHelpAlertCount",
									displayName: this.$root.htmlConst.cons_107_sv_header,
								},
							];
							if (localStorage.getItem('usedChartF2FList')) {
								let localConfig = JSON.parse(localStorage.getItem('usedChartF2FList'))
								this.$root.unusedChartF2FList = this.$root.usedChartF2FList.filter(item => localConfig.filter(ele => ele.name == item.name).length == 0)
								this.$root.usedChartF2FList = this.$root.usedChartF2FList.filter(item => localConfig.filter(ele => ele.name == item.name).length > 0)
							}
						}
					},
					(err) => {
						console.log(err);
					}
				);
			}
		},
		filterGroup(value, row) {
			return row.groupName === value;
		},
		filterSV(value, row) {
			return row.role === value;
		},
		filterModel(value, row) {
			return row.model === value;
		},
		filterStatus(value, row) {
			return row.presence === value;
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: お問い合わせ者氏名フィルターメソッド
		//           - callerNumberから取得した顧客名でフィルタリング
		// ==========================================
		filterCustomerName(value, row) {
			const customerName = this.getCustomerName(row.callerNumber);
			return customerName === value;
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: エージェント氏名フィルターメソッド
		// ==========================================
		filterOperatorName(value, row) {
			return row.operatorName === value;
		},
		getTableDetail: function () {
			api.getPresenceTableDetail(this.$root.user.user_id).then(
				(res) => {
					if (res && res.data) {
						let data = res.data;
						// let data = data2
						this.$root.presenceTableData = data.output_list;
						for (let groupName of data.output_list.map((v) => v.groupName)) {
							let groupNameFilter = {};
							if (
								!this.$root.groupFilters.map((v) => v.value).includes(groupName)
							) {
								groupNameFilter.text = groupName;
								groupNameFilter.value = groupName;
								this.$root.groupFilters.push(groupNameFilter);
							}
						}
						for (let role of data.output_list.map((v) => v.role)) {
							let svFilter = {};
							if (!this.$root.svFilters.map((v) => v.value).includes(role)) {
								svFilter.text = role;
								svFilter.value = role;
								this.$root.svFilters.push(svFilter);
							}
						}
						for (let model of data.output_list.map((v) => v.model)) {
							let modelFilter = {};
							if (
								!this.$root.modelFilters.map((v) => v.value).includes(model)
							) {
								modelFilter.text = model;
								modelFilter.value = model;
								this.$root.modelFilters.push(modelFilter);
							}
						}
						// ==========================================
						// 修正日時: 2026-01-22
						// 修正内容: 応対不可ステータスのフィルター条件からの除外
						//           - .envの設定（VUE_APP_EXCLUDE_OFFLINE_STATUS）で除外制御
						//           - フィルター選択肢から応対不可を除外
						// ==========================================
						// .envの設定で除外するかどうかを制御
						const excludeOffline = process.env.VUE_APP_EXCLUDE_OFFLINE_STATUS !== 'false';
						const offlineStatus = this.$root.htmlConst?.cons_168_status_offline;
						if (excludeOffline && offlineStatus) {
							// 既存のフィルターリストから「応対不可」を削除
							this.$root.statusFilters = this.$root.statusFilters.filter(
								(filter) => filter.value !== offlineStatus
							);
						}
						for (let presence of data.output_list.map((v) => v.presence)) {
							// .envの設定に基づいて「応対不可」をフィルター条件から除外
							if (excludeOffline && presence === offlineStatus) {
								continue;
							}
							let statusFilter = {};
							if (
								!this.$root.statusFilters.map((v) => v.value).includes(presence)
							) {
								statusFilter.text = presence;
								statusFilter.value = presence;
								this.$root.statusFilters.push(statusFilter);
							}
						}
						// ==========================================
						// 修正日時: 2026-01-26
						// 修正内容: エージェント氏名フィルターオプション生成
						//           - operatorNameから一意の値を抽出
						// ==========================================
						if (!this.$root.operatorNameFilters) {
							this.$root.operatorNameFilters = [];
						}
						for (let operatorName of data.output_list.map((v) => v.operatorName)) {
							if (operatorName) {
								let operatorNameFilter = {};
								if (
									!this.$root.operatorNameFilters.map((v) => v.value).includes(operatorName)
								) {
									operatorNameFilter.text = operatorName;
									operatorNameFilter.value = operatorName;
									this.$root.operatorNameFilters.push(operatorNameFilter);
								}
							}
						}
						// ==========================================
						// 修正日時: 2026-01-26
						// 修正内容: お問い合わせ者氏名フィルターオプション生成
						//           - 顧客名キャッシュから一意の値を抽出
						//           - 非同期で取得されるため、watchで更新
						// ==========================================
						if (!this.$root.customerNameFilters) {
							this.$root.customerNameFilters = [];
						}
						// 顧客名フィルターは顧客情報取得後に更新される
						this.updateCustomerNameFilters();
						this.$root.presenceNgCount = data.ngCount;
						// this.$root.presenceLongTimeCount = data.longTimeCount;
						this.$root.ngWordsConfig = data.ngWordsConfig;
						this.$root.longTimeConfig = data.longTimeConfig;
						this.$root.presenceSVDependCount = data.svDependCount;
						// ==========================================
						// 修正日時: 2026-01-22
						// 修正内容: タイムゾーンオフセットの保存
						//           - バックエンドから取得したタイムゾーン情報を保存
						//           - フロントエンドでのタイムゾーン計算に使用（現在は未使用だが将来の拡張用）
						// ==========================================
						// タイムゾーンオフセットを保存（デフォルトは9）
						this.$root.timeZoneOffset = data.timeZoneOffset || 9;
						this.loading = false;
						this.$root.isDataLoading = false;

					}
				},
				(err) => {
					console.log(err);
				}
			);
			// ==========================================
			// 修正日時: 2026-01-26
			// 修正内容: TelDetailTableとのマージ - telRealTimeTableDataも取得
			//           - PresenceDetailTableでTelDetailTableの列を表示するため
			// ==========================================
			api.getTelRealTimeTableDetail(this.$root.user.user_id).then(
				(res) => {
					if (res && res.data) {
						this.$root.telRealTimeTableData = res.data.output_list;
					}
				},
				(err) => {
					console.log(err);
				}
			);
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - データ取得メソッド
		//           - presenceRowに対応するtelRealTimeTableDataを取得
		//           - ボイスボットはcallerNumberでマッチング、通常はloginIdでマッチング
		// ==========================================
		normalizedRootUserName() {
			const n = this.$root.user && this.$root.user.name;
			return String(n || '').replace(/\s+/g, '');
		},
		normalizedSvHelperAtIndex(tel) {
			if (!tel || tel.svhelperString == null || tel.svhelperString === '') {
				return '';
			}
			const parts = String(tel.svhelperString).split(',');
			const rawCount = tel.svhelpRequestCount;
			const count = Number(rawCount);
			let idx;
			if (rawCount === '' || rawCount == null || count === 0) {
				idx = parts.length - 1;
			} else if (Number.isFinite(count) && count > 0) {
				idx = count - 1;
			} else {
				idx = parts.length - 1;
			}
			if (idx < 0 || idx >= parts.length) {
				return '';
			}
			return String(parts[idx] || '').replace(/\s+/g, '');
		},
		svSupportResetButtonVisible(tel) {
			if (!tel || tel.svhelpStatus !== 'onSupport') {
				return false;
			}
			const raw = tel.svhelpRequestCount;
			const count = Number(raw);
			if (raw === '' || raw == null || count === 0) {
				return true;
			}
			return this.normalizedSvHelperAtIndex(tel) === this.normalizedRootUserName();
		},
		svSupportDisabledButtonVisible(tel) {
			if (!tel || tel.svhelpStatus !== 'onSupport') {
				return false;
			}
			const count = Number(tel.svhelpRequestCount);
			if (!Number.isFinite(count) || count <= 0) {
				return false;
			}
			return this.normalizedSvHelperAtIndex(tel) !== this.normalizedRootUserName();
		},
		// Reuse the wavView header rendering for the category column.
		renderCategoryHeader(h) {
			return h('div', {
				style: {
					lineHeight: '20px',
					textAlign: 'center',
          width: '100%',
          whiteSpace: 'normal',
				},
				domProps: {
					innerHTML: this.$root.htmlConst.cons_320_table_header_category
				}
			});
		},
		getTelDataForRow(presenceRow) {
			if (!this.$root.telRealTimeTableData || !presenceRow) {
				return null;
			}
			// ボイスボット（queueNum === '8899'）の場合はcallerNumberで検索
			if (presenceRow.queueNum === '8899') {
				const telData = this.$root.telRealTimeTableData.filter(
					telRow => telRow.callerNumber === presenceRow.callerNumber
				);
				return telData.length > 0 ? telData[0] : null;
			}
			// 通常のオペレーターはloginIdで検索
			const telData = this.$root.telRealTimeTableData.filter(
				telRow => telRow.loginId === presenceRow.loginId
			);
			return telData.length > 0 ? telData[0] : null;
		},
		// Read the category tag from the real-time call row and fall back to an empty string.
		getCategoryTagForRow(presenceRow) {
			const telRow = this.getTelDataForRow(presenceRow);
			return telRow && telRow.categoryTag ? telRow.categoryTag : '';
		},
		// 要注意列のツールチップ用：NGワード・NGマナーの文言を結合して返す
		getNgWordTextForRow(presenceRow) {
			const tel = this.getTelDataForRow(presenceRow);
			if (!tel) return '';
			const h = this.$root.htmlConst || {};
			const parts = [];
			if (tel.telQuestionerNgWords) {
				// parts.push((h.cons_124_table_header_questioner || '質問者') + ' NG: ' + tel.telQuestionerNgWords);
				parts.push(tel.telQuestionerNgWords);
			}
			if (tel.telOperatorNgWords) {
				// parts.push((h.cons_125_table_header_operator || 'オペレーター') + ' NG: ' + tel.telOperatorNgWords);
				parts.push(tel.telOperatorNgWords);
			}
			if (tel.telOperatorNgManners) {
				// parts.push((h.cons_150_table_header_ngmanner || 'NGマナー') + ': ' + tel.telOperatorNgManners);
				parts.push(tel.telOperatorNgManners);
			}
			return parts.join('\n');
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - SVヘルプリセット
		//           - TelDetailTableのresetSvHelpClickメソッドを移植
		// ==========================================
		resetSvHelpClick(row) {
			api.resetSvhelpOnSupport("NEXMO_ASTERISK_PBX_MODE", row.operatorId, this.$root.user.user_id, '').then(
				(res) => {
					if (res && res.data) {
						console.log("svhelpOnSupport reset success");
					}
				},
				(err) => {
					console.log(err);
				}
			);
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - モニタリング関連メソッド
		//           - ユーザーが対象の通話をモニタリング中かチェック
		// ==========================================
		checkUserMonitor(row) {
			let hasUserNameFlg = false;
			if (row.monitorName) {
				let userName = this.$root.user.name;
				let userNameArr = userName.split(' ');
				userName = userNameArr[0] + userNameArr[1];
				let monitorName = row.monitorName;
				let monitorNameArr = monitorName.split(',');
				for (let index in monitorNameArr) {
					if (monitorNameArr[index].replace(' ', '') == userName) {
						hasUserNameFlg = true;
						break;
					}
				}
			}
			return hasUserNameFlg
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - モニタリング開始クリック処理
		//           - モニタリング開始ボタンのクリック処理
		// ==========================================
		handleStartMonitoringClick(row) {
			// presenceRowからtelDataを取得
			const telRow = this.getTelDataForRow(row);
			if (!telRow) {
				return;
			}

			// lineListに555で始まるアクティブな通話があるか確認（SIP実態ベース）
			const lineList = this.$store.state.phone.lineList || [];
			const activeMonitorLine = lineList.find(
				(line) => line.LineNumber && line.LineNumber.startsWith('555')
			);

			let isMonitoring = !!activeMonitorLine;
			let currentRowMonitoring = {};

			if (!isMonitoring) {
				// サーバー側の監視フラグも確認（フォールバック）
				for (let telDataRow of this.$root.telRealTimeTableData) {
					if (this.checkUserMonitor(telDataRow)) {
						isMonitoring = true;
						currentRowMonitoring = telDataRow;
						break;
					}
				}
			} else {
				// lineListから現在モニタリング中の行をtelRealTimeTableDataから探す
				const activeNum = activeMonitorLine.LineNumber.substring(3); // 555を除去
				currentRowMonitoring = (this.$root.telRealTimeTableData || []).find(
					(d) => d.callerNumber === activeNum || d.queueNum === activeNum
				) || {};
			}

			if (isMonitoring) {
				this.isCreateThreeCallSubmit = true;
				this.startNewMonitoringConfirmDialogVisible = true;
			} else {
				this.isCreateThreeCallSubmit = true;
				this.confirmDialogVisible = true;
			}
			this.isMonitoring = isMonitoring;
			this.currentRowMonitoring = currentRowMonitoring;
			this.currentRowClicked = telRow;
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - モニタリング開始
		//           - ボイスボットの場合は555 + callerNumber、通常は555 + queueNum
		// ==========================================
		startMonitoring() {
			//  Close text Monitoring drawer 
			// if (this.dialogVisible){
			// 	this.handleClose();
			// }
			if (this.isCreateThreeCallSubmit) {
				this.isCreateThreeCallSubmit = false
				let dialNum;
				if (this.currentRowClicked.queueNum === '8899' && this.currentRowClicked.callerNumber) {
					dialNum = '555'.concat(this.currentRowClicked.callerNumber);
				} else {
					dialNum = '555'.concat(this.currentRowClicked.queueNum);
				}
				console.log('dialNum....', dialNum)
				
				// モニタリング中のダイヤル番号を保存（通話終了検知用）
				this.monitoringDialNum = dialNum;

				this.$store.dispatch('phone/setShowPhone', true)
				this.$store.commit('phone/setCurrentCallerNum', dialNum)
				this.setMonitorInfo(this.currentRowClicked)
				this.$nextTick(() => {
					this.$store.commit('phone/setAutoStartMonitoringCall', true)
				})
				
				this.$store.state.startMonitoring = true
				this.confirmDialogVisible = false;
			}
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - 既存モニタリング停止して新規開始
		// ==========================================
		startNewMonitoring() {
			this.startNewMonitoringConfirmDialogVisible = false;
			// 既存の通話を切断してから新規発信（SIPセッション終了を待つため遅延を入れる）
			this.endMonitoring(this.currentRowMonitoring);
			setTimeout(() => {
				this.startMonitoring();
			}, 500);
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - モニタリング終了
		//           - ボイスボットの場合は555 + callerNumber、通常は555 + queueNum
		// ==========================================
		endMonitoring(row) {
			let dialNum;
			if (typeof row === 'object' && row !== null) {
				if (row.queueNum === '8899' && row.callerNumber) {
					dialNum = '555'.concat(row.callerNumber);
				} else {
					dialNum = '555'.concat(row.queueNum || row);
				}
			} else {
				dialNum = '555'.concat(row);
			}
			this.$SIP.endSession(dialNum);
			this.$store.state.startMonitoring = false
			this.$store.commit('phone/setMonitorInfoEmpty')
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: テキストモニタリングで空白のみの発言を非表示
		//           - ブランク・スペース・改行のみのtextは表示しない
		// ==========================================
		isTextBlank(text) {
			if (text == null || text === undefined) return true;
			if (typeof text !== 'string') return true;
			return text.trim() === '';
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - テキストモニタリング表示
		//           - テキストモニタリングダイアログを開く
		// ==========================================
		viewAllText(index, row) {
			// presenceRowからtelDataを取得
			const telRow = this.getTelDataForRow(row);
			if (!telRow) {
				return;
			}
			// End Call Monitoring 
			// if(this.$store.state.phone.showPhone) {
			// 	this.endMonitoring(telRow);
			// 	this.$store.dispatch('phone/setShowPhone', false)
			// }
			this.index = index;
			this.dialogVisible = true;
			this.allTextData = [];
			this.multipleSelection = [];
			let self = this;
			self.loading = true;
			this.dialogOperatorId = telRow.loginId;
			this.dialogTitle = telRow.operatorName;
			this.isTextDrawerCollapsed = false;
			this.activeUserInfoCollapse=['userInfo']
			// ==========================================
			// 修正日時: 2026-01-26
			// 修正内容: お問い合わせ者の電話番号を保存
			//           - テキストモニタリングダイアログで顧客情報を表示するため
			// ==========================================
			this.dialogCallerNumber = telRow.callerNumber || row.callerNumber;
			
			// 顧客情報を事前に取得（テキストデータ取得前に）
			if (this.dialogCallerNumber) {
				this.getCustomerName(this.dialogCallerNumber);
			}

			if (telRow.queueNum === '8899') {
				self.getUserAllText();
				self.userTextInterval = window.setInterval(() => {
					setTimeout(self.getUserAllText(), 0);
				}, 5000);
				self.loading = false;
			} else {
				let data = {
					user_id: this.$root.user.user_id,
					operator_id: self.dialogOperatorId,
					svName: self.$root.user.name,
				};

				api.saveTextStatus(data).then(
					() => {
						self.getUserAllText();
						self.userTextInterval = window.setInterval(() => {
							setTimeout(self.getUserAllText(), 0);
						}, 5000);
						self.loading = false;
					},
					(err) => {
						console.log(err);
					}
				);
			}
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - テキスト取得
		//           - ボイスボットは電話番号ベース、通常はloginIdベースで取得
		// ==========================================
		getUserAllText: function () {
			let _this = this;
			// 初回表示時のみ先頭に戻す（ポーリング更新でユーザーのスクロール位置を奪わないため）
			const shouldResetScroll = !_this.allTextData || _this.allTextData.length === 0;
			// telRealTimeTableDataから対応する行を探す
			const telRow = this.$root.telRealTimeTableData[_this.index];
			
			if (telRow && telRow.queueNum === '8899') {
				//2026/03/31 Get ALL TEXT BY CHannel ID instead of by phone
				//let phoneNumber = telRow.callerNumber;
				//api.getUserAllTextByPhone(phoneNumber).then(
				let channelId= telRow.channelId
				api.getUserAllTextByChannel(channelId).then(
					(res) => {
						if (res && res.data) {
							// ブランク・スペース・改行のみの発言を除外して表示
							_this.allTextData = (res.data.output_list || []).filter(
								(item) => !_this.isTextBlank(item.text)
							);
							// ==========================================
							// 修正日時: 2026-01-26
							// 修正内容: お問い合わせ者の氏名とロゴを追加
							//           - 取得したテキストデータに顧客情報を追加
							// ==========================================
						_this.enrichTextDataWithCustomerInfo();
						// ==========================================
						// 修正日時: 2026-04-02
						// 修正内容: キーワードハイライト機能追加
						//           - テキスト取得後にキーワードをハイライト
						// ==========================================
						if (telRow) {
							_this.wordArr = _this.generateWordArr(telRow);
							_this.highlightTextData();
						}
						_this.searchAllText("load");
						_this.$nextTick(() => {
							if (_this.$refs.multipleTable) {
								// _this.$refs.multipleTable.bodyWrapper.scrollTop =
								// 	_this.$refs.multipleTable.bodyWrapper.scrollHeight;
								if (shouldResetScroll) {
									// Open dialog should start from the top.
									_this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
								}
							}
						});
					}
				},
				(err) => {
					console.log(err);
				}
			);
		} else {
			api.getUserAllText(this.dialogOperatorId).then(
				(res) => {
					if (res && res.data) {
						// ブランク・スペース・改行のみの発言を除外して表示
						_this.allTextData = (res.data.output_list || []).filter(
							(item) => !_this.isTextBlank(item.text)
						);
						// ==========================================
						// 修正日時: 2026-01-26
						// 修正内容: お問い合わせ者の氏名とロゴを追加
						//           - 取得したテキストデータに顧客情報を追加
						// ==========================================
						_this.enrichTextDataWithCustomerInfo();
						// ==========================================
						// 修正日時: 2026-04-02
						// 修正内容: キーワードハイライト機能追加
						//           - テキスト取得後にキーワードをハイライト
						// ==========================================
						if (telRow) {
							_this.wordArr = _this.generateWordArr(telRow);
							_this.highlightTextData();
						}
						_this.searchAllText("load");
						_this.$nextTick(() => {
							if (_this.$refs.multipleTable) {
								// _this.$refs.multipleTable.bodyWrapper.scrollTop =
								// 	_this.$refs.multipleTable.bodyWrapper.scrollHeight;
								if (shouldResetScroll) {
									// Open dialog should start from the top.
									_this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
								}
							}
						});
						}
					},
					(err) => {
						console.log(err);
					}
				);
			}
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: テキストデータにお問い合わせ者の氏名とロゴを追加
		//           - callerNumberから顧客情報を取得して、allTextDataに追加
		// ==========================================
		enrichTextDataWithCustomerInfo() {
			if (!this.dialogCallerNumber || !this.allTextData) {
				return;
			}
			
			// 顧客名を取得（キャッシュから）
			const customerName = this.getCustomerName(this.dialogCallerNumber);
			const customerInfo = this.customerInfoCache && this.customerInfoCache[this.dialogCallerNumber];
			
			// allTextDataのお問い合わせ者メッセージに顧客情報を追加
			for (let textData of this.allTextData) {
				if (textData.user === 'お問い合わせ者') {
					// 氏名が取得できている場合はusernameに設定
					if (customerName && customerName !== 'loading' && !textData.username) {
						textData.username = customerName;
					}
					// ロゴが取得できている場合はcustomerLogoに設定
					// APIレスポンスではlogo_urlという名前で返される
					if (customerInfo && customerInfo.logo_url && !textData.customerLogo) {
						textData.customerLogo = customerInfo.logo_url;
					}
				}
			}
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - テキストモニタリングダイアログクローズ
		// ==========================================
		handleClose() {
			let self = this;
			self.allTextData = [];
			self.search = "";
			self.oldSearch = "";
			self.multipleSelection = [];
			this.dialogVisible = false;
			clearInterval(this.userTextInterval);

			const telRow = self.$root.telRealTimeTableData[self.index];
			if (telRow && telRow.queueNum === '8899') {
				return;
			}

			let data = {
				user_id: this.$root.user.user_id,
				operator_id: self.dialogOperatorId,
				svName: self.$root.user.name,
			};
			api.closeDialog(data).then(
				() => { },
				(err) => {
					console.log(err);
				}
			);
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - テキスト検索
		// ==========================================
		searchAllText(action) {
			if (action == "search") {
				this.searchIndex = 1;
				this.multipleSelection = [];
			}
			if (this.oldSearch) {
				for (let text of this.allTextData) {
					if (text.text.includes(this.oldSearch)) {
						text.text = text.text.replace(
							RegExp(
								'<span class="resultOn">' + this.oldSearch + "</span>",
								"g"
							),
							this.oldSearch
						);
						text.text = text.text.replace(
							RegExp(
								'<span class="resultOff">' + this.oldSearch + "</span>",
								"g"
							),
							this.oldSearch
						);
					}
				}
			}
			if (this.search) {
				let tmpmultipleSelection = [];
				let allCount = 0;
				for (var i = 0; i < this.allTextData.length; i++) {
					let count = 0;
					if (this.allTextData[i].text.includes(this.search)) {
						this.allTextData[i].text = this.allTextData[i].text.replace(
							RegExp(this.search, "g"),
							'<span class="resultOn">' + this.search + "</span>"
						);
						count = this.allTextData[i].text.split(this.search).length - 1;
					}
					for (var j = 1; j <= count; j++) {
						let data = {
							rowIndex: i,
							rowSearchIndex: j,
							searchIndex: allCount + j,
						};
						tmpmultipleSelection.push(data);
					}
					allCount = allCount + count;
				}
				this.multipleSelection = tmpmultipleSelection;
				if (this.multipleSelection.length > 0) {
					// load 時は件数が変わるため、分子を有効範囲に収める（新着で減った場合の undefined 防止）
					if (this.searchIndex < 1) {
						this.searchIndex = 1;
					}
					if (this.searchIndex > this.multipleSelection.length) {
						this.searchIndex = this.multipleSelection.length;
					}
					let item = find(this.multipleSelection, {
						searchIndex: this.searchIndex,
					});
					if (!item) {
						this.searchIndex = 1;
						item = this.multipleSelection[0];
					}
					let rowContentList = this.allTextData[item.rowIndex].text.split(
						this.search
					);
					let newContent = "";
					for (var m = 0; m < rowContentList.length; m++) {
						if (m == item.rowSearchIndex - 1) {
							newContent =
								newContent +
								rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
						} else {
							newContent = newContent + rowContentList[m];
						}
						if (m != rowContentList.length - 1) {
							newContent = newContent + this.search;
						}
					}
					this.allTextData[item.rowIndex].text = newContent;

					this.setCurrentRow(item.rowIndex);
				} else {
					this.searchIndex = 1;
				}
			} else {
				// 検索語なし: ポーリング後も古い件数が残らないようリセット
				this.multipleSelection = [];
				this.searchIndex = 1;
			}
			this.oldSearch = this.search;
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - 次の検索結果選択
		// ==========================================
		downSelect() {
			for (let text of this.allTextData) {
				text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
			}
			if (this.searchIndex >= this.multipleSelection.length) {
				this.searchIndex = 1;
			} else {
				this.searchIndex += 1;
			}
			const item = find(this.multipleSelection, {
				searchIndex: this.searchIndex,
			});
			let rowContentList = this.allTextData[item.rowIndex].text.split(
				this.search
			);
			let newContent = "";
			for (var m = 0; m < rowContentList.length; m++) {
				if (m == item.rowSearchIndex - 1) {
					newContent =
						newContent +
						rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
				} else {
					newContent = newContent + rowContentList[m];
				}
				if (m != rowContentList.length - 1) {
					newContent = newContent + this.search;
				}
			}
			this.allTextData[item.rowIndex].text = newContent;
			this.$nextTick(() => this.setCurrentRow(item.rowIndex));
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - 前の検索結果選択
		// ==========================================
		upSelect() {
			for (let text of this.allTextData) {
				text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
			}
			if (this.searchIndex == 1) {
				this.searchIndex = this.multipleSelection.length;
			} else {
				this.searchIndex -= 1;
			}
			const item = find(this.multipleSelection, {
				searchIndex: this.searchIndex,
			});
			let rowContentList = this.allTextData[item.rowIndex].text.split(
				this.search
			);
			let newContent = "";
			for (var m = 0; m < rowContentList.length; m++) {
				if (m == item.rowSearchIndex - 1) {
					newContent =
						newContent +
						rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
				} else {
					newContent = newContent + rowContentList[m];
				}
				if (m != rowContentList.length - 1) {
					newContent = newContent + this.search;
				}
			}
			this.allTextData[item.rowIndex].text = newContent;
			this.$nextTick(() => this.setCurrentRow(item.rowIndex));
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: TelDetailTableとのマージ - 検索結果の行スクロール
		// ==========================================
		setCurrentRow(index) {
			if (this.multipleSelection.length == 0) {
				return false;
			} else {
				const targetTop = this.$refs.multipleTable.$el
					.querySelectorAll(".el-table__body tr")[index].getBoundingClientRect().top;
				const containerTop = this.$refs.multipleTable.$el
					.querySelector(".el-table__body")
					.getBoundingClientRect().top;
				const scrollParent = this.$refs.multipleTable.$el.querySelector(
					".el-table__body-wrapper"
				);
				let scrollHeight = targetTop - containerTop;
				scrollParent.scrollTop = scrollHeight;
			}
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: お問い合わせ者氏名取得メソッド
		//           - callerNumberから顧客情報を取得
		//           - キャッシュを使用してAPI呼び出しを最適化
		// ==========================================
		getCustomerName(callerNumber) {
			if (!callerNumber) {
				return '';
			}
			// キャッシュに存在する場合はそれを返す
			if (this.customerNameCache[callerNumber]) {
				return this.customerNameCache[callerNumber];
			}
			// 取得中の場合は空文字を返す（重複リクエストを防ぐ）
			if (this.customerNameCache[callerNumber] === 'loading') {
				return '';
			}
			// 非同期で顧客情報を取得
			this.fetchCustomerName(callerNumber);
			return '';
		},
		// ==========================================
		// 修正日時: 2026-05-08
		// 修正内容: お問い合わせ者情報取得メソッド
		//           - Phone Component の実装を参考
		//           - customerInfoCache から取得
		// ==========================================
		getCustomerEmail() {
			if (!this.dialogCallerNumber) {
				return '';
			}
			const customerInfo = this.customerInfoCache && this.customerInfoCache[this.dialogCallerNumber];
			return this.getCustomerType(this.dialogCallerNumber) == 'external'? (customerInfo?.mail || ''): (customerInfo?.address || '')
		},
		getCustomerLogo() {
			if (!this.dialogCallerNumber) {
				return '';
			}
			const customerInfo = this.customerInfoCache && this.customerInfoCache[this.dialogCallerNumber];
			return customerInfo && customerInfo.logo_url ? customerInfo.logo_url : '';
		},
		getCustomerAddress() {
			if (!this.dialogCallerNumber) {
				return '';
			}
			const customerInfo = this.customerInfoCache && this.customerInfoCache[this.dialogCallerNumber];
			return customerInfo && customerInfo.current_address ? customerInfo.current_address : '';
		},
		// ==========================================
		// 修正日時: 2026-05-08
		// 修正内容: オペレーター情報取得メソッド
		//           - Phone Component の実装を参考
		//           - telRealTimeTableData から取得
		// ==========================================
		getOperatorExtension() {
			const telRow = this.$root.telRealTimeTableData[this.index];
			if (!telRow) return '';
			
			if (telRow.queueNum === '8899') {
				return `内線番号: ${telRow.customizedQueueNum || telRow.queueNum}`;
			}
			return `内線番号: ${telRow.queueNum || ''}`;
		},
		getOperatorEmail() {
			const telRow = this.$root.telRealTimeTableData[this.index];
			if (!telRow) return '';
			return telRow.operatorEmail || '';
		},
		getOperatorLogo() {
			const telRow = this.$root.telRealTimeTableData[this.index];
			if (!telRow) return '';
			if (telRow.queueNum === '8899'){
				return this.voicebotAvatar
			} 
			return telRow.operatorLogo || '';
		},
		getCustomerType(callerNumber){
			return (callerNumber.length >5 || (callerNumber.length == 5 && callerNumber.startsWith('9') )) ? 'external' : 'internal'
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: 顧客情報取得（非同期）
		//           - APIを呼び出して顧客名を取得し、キャッシュに保存
		// ==========================================
		fetchCustomerName(callerNumber) {
			// ローディング中フラグを設定
			this.customerNameCache[callerNumber] = 'loading';
			let customerType = this.getCustomerType(callerNumber)
			return api.getUserInfoByType({ phonenum: callerNumber }, customerType).then(
				(res) => {
					if (res && res.data && res.data.code === 0 && res.data.data && res.data.data.length > 0) {
						const customer = res.data.data[0];
						// firstnameとlastnameを結合して顧客名を作成
						const customerName = (customer.lastname || '') + ' ' + (customer.firstname || '');
						this.customerNameCache[callerNumber] = customerName.trim() || '';
						// 顧客情報オブジェクトも保存（ロゴ用）
						if (!this.customerInfoCache) {
							this.customerInfoCache = {};
						}
						this.customerInfoCache[callerNumber] = customer;
					} else {
						// 取得できなかった場合は空文字を設定
						this.customerNameCache[callerNumber] = '';
					}
					// 顧客名フィルターを更新
					this.updateCustomerNameFilters();
					// テキストモニタリングダイアログが開いている場合は、テキストデータを更新
					if (this.dialogVisible && this.dialogCallerNumber === callerNumber) {
						this.enrichTextDataWithCustomerInfo();
					}
					// テーブルを再描画
					this.$nextTick(() => {
						if (this.$refs.tableRef) {
							this.$refs.tableRef.doLayout();
						}
					});
				},
				(err) => {
					console.log('Failed to fetch customer info:', err);
					// エラー時は空文字を設定
					this.customerNameCache[callerNumber] = '';
					// 顧客名フィルターを更新
					this.updateCustomerNameFilters();
				}
			);
		},
		// ==========================================
		// 修正日時: 2026-01-26
		// 修正内容: お問い合わせ者氏名フィルターオプション更新
		//           - 顧客名キャッシュから一意の値を抽出してフィルターオプションを生成
		// ==========================================
		updateCustomerNameFilters() {
			if (!this.$root.customerNameFilters) {
				this.$root.customerNameFilters = [];
			}
			// キャッシュから一意の顧客名を抽出（空文字と'loading'を除外）
			const uniqueCustomerNames = [...new Set(
				Object.values(this.customerNameCache).filter(name => name && name !== 'loading')
			)].sort();
			
			// 既存のフィルターをクリアして再生成
			this.$root.customerNameFilters = uniqueCustomerNames.map(name => ({
				text: name,
				value: name
			}));
		},
		setMonitorInfo(row){
			if(row.queueNum ==='8899'){
				let monitorInfo={
					operatorName: row.operatorName, 
					operatorNum: row.customizedQueueNum,
				} 
				this.$store.commit('phone/setMonitorInfo', monitorInfo)
			}else{
				let params={
					phonenum:row.queueNum
				}
				api.getUserInfoByType(params,'internal').then((res)=>{
					if(res.data != 'fail'){
						if(res.data.data[0]){
							let userInfo = res.data.data[0]
							console.log("userInfo",userInfo)
							let monitorInfo = {
								operatorName: (userInfo.lastname || '') + (userInfo.firstname || ''),
								operatorNum: row.queueNum,
								operatorLogo: userInfo.logo_url,
								operatorEmail: userInfo.address || ''
							}
							this.$store.commit('phone/setMonitorInfo', monitorInfo)
						}
					}
				},(err)=>{
					console.log(err);
				})
			}
			
		},
		// ==========================================
		// 修正日時: 2026-05-08
		// 修正内容: ユーザー情報カード用のヘルパーメソッド
		//           - 顧客ロゴとメールアドレスを取得
		// ==========================================
		getCustomerLogo() {
			if (!this.dialogCallerNumber) {
				return '';
			}
			const customerInfo = this.customerInfoCache && this.customerInfoCache[this.dialogCallerNumber];
			return customerInfo && customerInfo.logo_url ? customerInfo.logo_url : '';
		},
		// ==========================================
		// 修正日時: 2026-04-02
		// 修正内容: wavViewからキーワードハイライト機能を移植
		//           - 要注意/NG/Wow/NGマナーワードの配列を生成
		// ==========================================
		generateWordArr(record){
			if (!record) return [];
			
			// 要注意ワード・NGワード・Wowワード・NGマナーワードをパース
			const warningWordObject = this.parseWords('warningWordType', record.telWarningWords);
			const ngWordObject = this.parseWords('ngwordQType', record.telQuestionerNgWords);
			const wowWordObject = this.parseWords('ngWowType', record.telQuestionerWowWords);
			const ngMannerObject = this.parseWords('ngMannerType', record.telOperatorNgManners);
			
			return [...warningWordObject, ...ngWordObject, ...wowWordObject, ...ngMannerObject];
		},
		// ==========================================
		// 修正日時: 2026-04-02
		// 修正内容: wavViewからワードパース機能を移植
		//           - カンマ区切りの文字列からワード配列を生成
		// ==========================================
		parseWords(type, wordString) {
			if (!wordString) {
				return [];
			}
			const words = wordString.split(",").map(w => w.trim()).filter(w => w !== "");
			// 各ワードの出現回数をカウント
			const map = {};
			words.forEach(w => {
				map[w] = (map[w] || 0) + 1;
			});
			// オブジェクト配列を返す
			return Object.keys(map).map(word => ({
				type,
				word,
				count: map[word],
				name: word + '(' + map[word] + ')'
			}));
		},
		// ==========================================
		// 修正日時: 2026-04-02
		// 修正内容: wavViewからテキストハイライト機能を移植
		//           - allTextData配列の各テキストにハイライトを適用
		// ==========================================
		highlightTextData() {
			if (!this.allTextData || this.allTextData.length === 0 || this.wordArr.length === 0) {
				return;
			}
			
			// 各テキストデータにハイライトを適用
			this.allTextData.forEach(item => {
				if (!item.text || this.isTextBlank(item.text)) {
					return;
				}
				
				let highlightedText = item.text;
				const isQuestioner = item.user === this.questioner;
				
				// ワード配列を順次適用
				this.wordArr.forEach(wordItem => {
					// エスケープが必要な正規表現特殊文字を処理
					const escapedWord = wordItem.word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
					const regex = new RegExp(escapedWord, 'g');
					
					// 要注意ワードは全メッセージに適用
					if (wordItem.type === 'warningWordType') {
						highlightedText = highlightedText.replace(regex, `<span class="warningWordType">${wordItem.word}</span>`);
					}
					// NGワードはお問い合わせ者のメッセージに適用
					else if (isQuestioner && wordItem.type === 'ngwordQType') {
						highlightedText = highlightedText.replace(regex, `<span class="ngwordQType">${wordItem.word}</span>`);
					}
					// Wowワードはお問い合わせ者のメッセージに適用
					else if (isQuestioner && wordItem.type === 'ngWowType') {
						highlightedText = highlightedText.replace(regex, `<span class="ngWowType">${wordItem.word}</span>`);
					}
					// NGマナーワードはオペレーターのメッセージに適用
					else if (!isQuestioner && wordItem.type === 'ngMannerType') {
						highlightedText = highlightedText.replace(regex, `<span class="ngMannerType">${wordItem.word}</span>`);
					}
				});
				
				item.text = highlightedText;
			});
		}
	},
};
</script>
<style lang="scss">
.presence-table thead.is-group th {
	background-color: #00b2f2 !important;
}

// ==========================================
// 修正日時: 2026-01-26
// 修正内容: ヘッダーの縦の余白を減らす
//           - ヘッダーセルのpaddingを調整
// ==========================================
.presence-table .el-table__header-wrapper th {
	padding: 5px 0 !important;
}

.presence-table .el-table__header-wrapper th .cell {
	padding: 0 10px;
	line-height: 1.2;
}

// .presence-table .el-table__header-wrapper {
// 	height: 49px;
// }
// .presence-table .el-table__body-wrapper {
// 	height: calc(100% - 49px) !important;
// }

/* .el-table th .gutter {
	display: table-cell !important;
} */
.el-table--border th.gutter:last-of-type {
	border: none;
	background: #F5F7FA !important;
}

.sup_btn {
	min-width: 105px;
	padding: 2px !important;
	display: flex;
	justify-content: center;
	align-items: center;

	img {
		display: inline-block;
		width: 13px;
		height: 13px;
		margin-bottom: -2px;
	}

	&.is-plain:focus,
	&.is-plain:hover {
		border-color: #DCDFE6 !important;
		color: #606266 !important;
	}
}

.sup_btn2 {
	background: transparent !important;
	margin-left: -2px;
	width: 15px;
	height: 15px;
	border-color: transparent !important;

	.sup_icon {
		border-radius: 2px;
		overflow: hidden;
		display: block;
		width: 15px;
		height: 15px;
		margin-bottom: -2px;
		color: #fff;
	}
}

// ==========================================
// 修正日時: 2026-01-26
// 修正内容: TelDetailTableとのマージ - スタイル追加
//           - テキストモニタリング、ダイアログ用スタイル
// ==========================================
.text-monitoring-drawer .tel-search-input {
	display: flex;
  align-items: center;
  // padding-left: 10px;
  // padding-right: 10px;
	.el-input__inner {
		height: 30px !important;
		line-height: 30px !important;
	}
	.tel-search-btn-group {
		margin-left: auto;
		display: flex;
		align-items: center;
		white-space: nowrap;
	}
	.gray-button {
		background-color: #909399 !important;
		border-color: #909399 !important;
		color: #fff !important;
	}

	.gray-button:hover,
	.gray-button:focus {
		background-color: #7d7f82 !important;
		border-color: #7d7f82 !important;
	}
	.search-nav-btn {
		width: 20px;
  	min-width: 20px;
  	height: 20px;
	}
}

.tel_dailog .el-dialog__header {
	background-color: #55BFE7;
	color: #FFFFFF;
}

.tel-monitoring {
	cursor: default;
}

/* 吹き出し・ユーザ名・ロゴを左右に分けるレイアウト */
.message_msg {
	display: flex;
	align-items: flex-start;
	margin-bottom: 12px;
}

.message_msg.left {
	flex-direction: row;
	justify-content: flex-start;
}

.message_msg.right {
	flex-direction: row-reverse;
	justify-content: flex-end;
}

.message_msg .user_msg {
	overflow: hidden;
	max-width: 80%;
	flex: 0 1 auto;
}

.message_msg .user_headshot {
	margin-top: 4px;
	width: 32px;
	height: 32px;
	min-width: 32px;
	border-radius: 50%;
	position: relative;
	overflow: hidden;
	background-color: #fff;
	flex-shrink: 0;
}

.message_msg.left .user_headshot {
	margin-right: 10px;
}

.message_msg.right .user_headshot {
	margin-left: 10px;
}

.message_msg .user_headshot img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.message_msg .speaker {
	font-size: 12px;
	margin-bottom: 2px;
}

.message_msg .user_text {
	font-size: 12px;
	padding: 4px 10px;
	border-radius: 10px;
	position: relative;
	text-align: left;
	display: inline-block;
}

.message_msg .user_text::before {
	content: "";
	position: absolute;
	top: 12px;
	width: 0;
	height: 0;
	border: 6px solid transparent;
}

.message_msg.left .user_msg {
	padding-left: 0;
	text-align: left;
}

.message_msg.left .user_headshot .transformDefaultUserLogo {
	transform: scaleX(-1);
}

.message_msg.left .user_text {
	background: #ddd;
}

.message_msg.left .user_text::before {
	left: -10px;
	border-right-color: #ddd;
}

.message_msg.right .user_msg {
	padding-right: 0;
	text-align: right;
}

.message_msg.right .speaker {
	text-align: right;
}

.message_msg.right .user_text {
	background: #c6e5ff;
}

.message_msg.right .user_text::before {
	right: -10px;
	border-left-color: #c6e5ff;
}

.is-red {
	background-color: #ffd7da;
	border-color: #ffa4ab;
	color: #000;
	margin-top: 7px;
	min-width: 5.625rem;
	min-height: 45px;
}

.is-blue {
	margin-top: 7px;
	min-width: 5.625rem;
	min-height: 45px;
}

.el-button.is-red:focus,
.el-button.is-red:hover {
	color: #000;
	background-color: #ffa4ab;
	border-color: #ff717c;
}


.call-ended-alert {
	background-color: #67c23a;
	color: #fff;
	padding: 6px 12px;
	border-radius: 4px;
	font-size: 13px;
	margin-bottom: 6px;
	display: flex;
	align-items: center;
}

.resultOn {
	background: yellow;
}

.resultOff {
	background: greenyellow;
}
.alert-warning-word {
  background-color:#ef5893; 
  color: #000; 
  float: left; 
  width: 100%
}
.alert-long-time {
	// background-color: #996633; 
	background-color:#d5934f;
	color: #000
}
.alert-ng-word {
	background-color: red; 
	color: #000; 
	float: left; 
	width: 100%;
}
.alert-wow-word {
	// background-color: #67c23a; 
	background-color:#00bfff;
	color: #000; 
	float: left; 
	width: 100%;
}
.alert-ng-manner {
  background-color:#ff9300;
  color: #000; 
	float: left; 
	width: 100%;
}
.result-content{
	.warningWordType {
		color: #ef5893;
		font-weight: 1300;
	}
	.ngwordQType {
		color: red;
		font-weight: 1300;
	}
	.ngWowType {
		color: #00bfff;
		font-weight: 1300;
	}
	.ngMannerType {
		color: #ff9300;
		font-weight: 1300;
	}
}
.col-category .cell {
  // text-align: left !important;
}
.col-button {
	width: 100%;
	border-radius: 0px;
	height: 20px;
}

// ==========================================
// Modified: 2026-04-30
// Change: Text monitoring drawer styles
//         - Allow background interaction (pointer-events)
//         - Similar to Phone drawer pattern
//         - Add collapse/expand functionality
// ==========================================
/* Text monitoring drawer - allow background clicks */
body.text-drawer-allow-back-clicks .el-drawer__wrapper {
	pointer-events: none;
}
body.text-drawer-allow-back-clicks .el-drawer {
	pointer-events: auto;
}
.text-monitoring-drawer .el-drawer__body {
	padding: 0;
	display: flex;
	flex-direction: column;
	height: 100%;
}
.text-monitoring-drawer .drawer-header {
	// padding: 15px 10px;
	padding-top: 15px;
	padding-left: 10px;
	padding-right: 10px;
	background-color: #FFFFFF;
	// color: #FFFFFF;
	flex-shrink: 0;
}
.text-monitoring-drawer .drawer-header-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 14px;
	line-height: 24px;
  margin-bottom: 10px;
}
.text-monitoring-drawer .drawer-title {
	flex: 1;
	// line-height: 1.5;
}
.text-monitoring-drawer .drawer-controls {
	display: flex;
	gap: 15px;
	margin-left: 15px;
}
.text-monitoring-drawer .control-btn {
	cursor: pointer;
	// padding: 5px 8px;
	border-radius: 4px;
	transition: background-color 0.3s;
	display: flex;
	align-items: center;
	justify-content: center;
}
.text-monitoring-drawer .control-btn:hover {
	background-color: rgba(255, 255, 255, 0.2);
}
.text-monitoring-drawer .control-btn i {
	// font-size: 16px;
	font-weight: bold;
}
.text-monitoring-drawer .result-content {
	flex: 1;
	overflow: hidden;
	padding: 10px;
	display: flex;
	flex-direction: column;
}
.text-monitoring-drawer .result-content .el-table {
	flex: 1;
	overflow: auto;
}
.text-monitoring-drawer .result-content .el-table .el-table__body-wrapper {
	max-height: none !important;
	overflow-y: auto;
	height: 100%;
}
/* Collapsed state - hide content area only, keep header visible */
.text-monitoring-drawer--collapsed {
  height: 50px!important;
	overflow: hidden;
}
.text-monitoring-drawer--collapsed .result-content {
	display: none;
}
.text-monitoring-drawer--collapsed .tel-search-input {
	display: none;
}
.text-monitoring-drawer--collapsed .call-ended-alert {
	display: none;
}
.text-monitoring-drawer--collapsed .el-drawer__body {
  padding: 0;
  overflow: hidden;
}
.text-monitoring-drawer--collapsed .user-info-card {
	display: none;
}

// ==========================================
// 修正日時: 2026-05-08
// 修正内容: ユーザー情報カードのスタイル追加（折りたたみ対応）
//           - Phone Component の .on_call_info スタイルを完全適用
//           - Customer と Operator 情報を1つのel-collapse-itemに配置
// ==========================================
.text-monitoring-drawer {
	// 折りたたみコンポーネントのスタイル
	.user-info-collapse {
		// margin: 0 0 8px 0;
		.user-info{
			background: #eff5f8;
			margin: 5px;
    	margin-bottom: 15px;
			box-shadow: 0px 1px 3px 2px rgba(167, 192, 202, 0.25);
		}
		
		.el-collapse-item {
			border: none;
			
			.el-collapse-item__header {
				height: 40px;
				line-height: 40px;
				// background-color: #f5f7fa;
				border: none;
				// border-bottom: 1px solid #e4e7ed;
				padding: 0 15px;
				font-weight: 500;
				// color: #303133;
				
				&:hover {
					// background-color: #eceff5;
				}
				
				.collapse-title {
					display: flex;
					align-items: center;
					width: 100%;
					
					i {
						margin-right: 8px;
						font-size: 16px;
						color: #409eff;
					}
					
					span {
						font-size: 14px;
					}
				}
			}
			
			.el-collapse-item__wrap {
				border: none;
				background-color: #ffffff;
			}
			
			.el-collapse-item__content {
				padding: 0;
			}
		}
		.collapse-title__time{
			margin-left:10px;
		}
	}
	
	.on_call_info {
		background: #0d0c0c;
		margin: 8px 15px;
		padding: 12px 8px;
		border-radius: 8px;
		display: flex;
		color: #fff;
		box-shadow: 0px 1px 3px 2px rgba(167, 192, 202, 0.25);
		
		.user_info {
			width: 90px;
			
			.avatar {
				display: flex;
				justify-content: center;
			}
			
			.name {
				line-height: 20px;
				font-size: 14px;
				white-space: nowrap;
				text-align: center;
				margin-top: 8px;
				
				.t_num {
					margin-top: 5px;
					font-size: 12px;
				}
			}
		}
		
		.user_info_margin-right {
			margin-right: 12px;
		}
		
		.call_info {
			flex: 1;
			display: flex;
			flex-direction: column;
			// justify-content: center;
			
			.address {
				// margin-bottom: 4px;
				font-size: 13px;
			}
			
			.call_num {
				// margin-bottom: 4px;
				// color: #4db1ec;
			}
			
			.email {
				font-size: 13px;
				// color: #b0b0b0;
			}
			
			.call_time {
				// color: #4db1ec;
			}
		}
	}
	
	.operator_call_info {
		justify-content: space-between;
		
		.call_info {
			margin-left: 10px;
		}
	}
}
</style>
